<template>
    <div style="background:#FAFAFA;" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
            <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
                <p class="paralax-cover-image-text">
                <div class="content_home" style="z-index: 1!important;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_vie.sunuassur.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_vie.sunuassur.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_vie.sunuassur.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_vie.sunuassur.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                    <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{ $t('devis.devis_vie.sunuassur.title[0]') }} <span class="font-weight-bold">{{ $t('devis.devis_vie.sunuassur.title[1]') }}</span>{{ $t('devis.devis_vie.sunuassur.title[2]') }} <span class="font-weight-bold">{{ $t('devis.devis_vie.sunuassur.title[3]') }}</span></p> <br>
                </div>
                <br>
                
                <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[0]') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[1]') }}</div>
                                    </li>
                                    <li class="step" id="thirtStep">
                                    <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[2]') }}</div>
                                  </li>
                                  <li class="step" id="fourStep">
                                    <div class="step-title">{{ $t('devis.devis_vie.sunuassur.stepper_title[3]') }}</div>
                                  </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                            <div class="wizard-progress-with-circle">
                                <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                            </div>
                            <div class="progress-bar-group">
                                <div class="progress-bar-custom" id="testup"></div>
                            </div>
                            <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                <li class="step" id="firstStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[0]') }}</div>
                                </li>
                                <li class="step" id="secondStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[1]') }}</div>
                                </li>
                                <li class="step" id="thirtStep">
                                    <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[4]') }}</div>
                                </li>
                              <li class="step" id="fourStep">
                                <div class="step-title text-center mr-4">{{ $t('devis.devis_vie.sunuassur.stepper_title[3]') }}</div>
                              </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">                           
                            <div class="page" v-show="step === 1">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepSimule" aria-hidden="true" aria-labelledby="step-StepSimule" class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                        <div class="btn-choice">
                                                            <input @click="switchCapital" v-model="choix" value="capital" type="radio" id="capital" name="offre" class="field-input">
                                                            <label for="capital" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.bouton_capital_label') }}</label>
                                                        </div>
                                                        <div class="btn-choice">
                                                            <input @click="switchMensuel" v-model="choix" value="mensuel" type="radio" id="mensualite" name="offre" class="field-input" >
                                                            <label for="mensualite" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.bouton_mensualite_label') }}</label>
                                                        </div>
                                                        <div class="btn-choice">
                                                            <input @click="switchRente" v-model="choix" value="rente" type="radio" id="rente" name="offre" class="field-input" >
                                                            <label for="rente" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.bouton_rente_label') }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-show="Capital">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.firstStep.titre_stepr_1') }}&nbsp;:</div>
                                                <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="field-group field-default">
                                                    <label for="date_naissance_assure" class="field-label">
                                                        {{ $t('devis.devis_vie.sunuassur.firstStep.date_naissance_assure_label') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_assure" @change="yearsDiff()" v-model="dateNaiss" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="field-group field-default">
                                                    <label for="date_naissance_benef" class="field-label">
                                                        {{$t('devis.devis_vie.sunuassur.firstStep.date_naissance_beneficiaire_label')}}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_benef" @change="yearsDiffBenef()" v-model="BenefiFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6" >
                                                            <div class="field-group field-default mb-4 mb-sm-0" v-if="isCapital">
                                                                <label for="capital_souhaite" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.capital_souhaite_label') }}</label>
                                                                <input v-money="money" @keyup="CheckFieldChange()" v-model="choixCapital.Capital" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.capital_souhaite_placeholder')" id="capital_souhaite" name="Step8" class="field-input">
                                                            </div>
                                                            <div class="field-group field-default mb-4 mb-sm-0" v-if="isRente">
                                                                <label for="rente_souhaite" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.rente_souhaite_label') }}</label>
                                                                <input v-money="money" @keyup="CheckFieldChange()" v-model="choixRente" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.rente_souhaite_placeholder')" id="rente_souhaite" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                       <!-- <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_capital" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                                <input @change="CheckFieldChange()" v-model="duree" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.duree_placeholder')" id="duree_capital" name="Step8" class="field-input">
                                                            </div>
                                                        </div>-->

                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_capital" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                                <select @change="CheckFieldChange()" v-model="duree" id="duree_capital" name="Step8" class="field-select">
                                                                    <option selected disabled>{{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.nombre_annee') }}</option>
                                                                    <option value="10">10 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="11">11 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="12">12 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="13">13 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="14">14 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="15">15 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="16">16 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="17">17 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="18">18 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="19">19 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="20">20 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_vie.sunuassur.firstStep.prime_mensuel_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>

                                                                </div>
                                                            </div>
                                                            <div class="mb-3 text-center">
                                                                <p v-if="this.isCapital == true" class="font-weight-light" style="color: #5a5a5a">{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[0]') }} <span style="color: #DC143C">{{ Capi.toLocaleString() }} FCFA</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[1]') }} <span style="color: #DC143C">1</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[2]') }} 
                                                                    <br>
                                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[3]') }} <span style="color: #DC143C">{{ choixCapital.Capital }} FCFA </span>{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[4]') }}
                                                                </p>

                                                                <p v-if="this.isRente == true" class="font-weight-light" style="color: #5a5a5a">{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[0]') }} <span style="color: #DC143C">{{ choixCapital.Capital }} FCFA</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[1]') }} <span style="color: #DC143C">1</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[2]') }}
                                                                    <br>
                                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[3]') }} <span style="color: #DC143C">{{ Capi.toLocaleString() }} FCFA </span>{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[4]') }}
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>

                                        <div v-show="Mensualite">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.firstStep.bouton_mensualite_label') }}&nbsp;:</div>
                                                <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="field-group field-default">
                                                    <label for="date_naissance_mensualite" class="field-label">
                                                        {{ $t('devis.devis_vie.sunuassur.firstStep.date_naissance_assure_label') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_mensualite" @change="yearsDiff()" v-model="dateNaiss" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="field-group field-default">
                                                    <label for="date_benef_mensualite" class="field-label">
                                                        {{$t('devis.devis_vie.sunuassur.firstStep.date_naissance_beneficiaire_label')}}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_benef_mensualite" @change="yearsDiffBenef()" v-model="BenefiFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                                </div>
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="mensualite_souhaite" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.mensualite_souhaite_label') }}</label>
                                                                <input v-money="money" @keyup="CheckFieldChange()" v-model="choixCapital.Mensuel" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.mensualite_souhaite_placeholder')" id="mensualite_souhaite" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <!--<div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_mensualite" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                                <input @change="CheckFieldChange()" v-model="duree" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.duree_placeholder')" id="duree_mensualite" name="Step8" class="field-input">
                                                            </div>
                                                        </div>-->

                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_mensualite" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                                <select @change="CheckFieldChange()" v-model="duree" id="duree_mensualite" name="Step8" class="field-select">
                                                                    <option selected disabled>{{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.nombre_annee') }}</option>
                                                                    <option value="10">10 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="11">11 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="12">12 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="13">13 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="14">14 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="15">15 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="16">16 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="17">17 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="18">18 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="19">19 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="20">20 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="Calculated_response!=null">
                                                                <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_vie.sunuassur.firstStep.capital_terme_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409">{{Calculated_response.toLocaleString()}} FCFA</div>

                                                                </div>
                                                            </div>
                                                            <div class="text-center">
                                                                <p class="font-weight-light" style="color: #5a5a5a">
                                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[0]') }}
                                                                    <span style="color: #DC143C">
                                                                                {{ Mensu.toLocaleString() }} FCFA
                                                                                </span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[1]') }} <span style="color: #DC143C">1</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[2]') }}
                                                                    <br>
                                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[3]') }}
                                                                    <span style="color: #DC143C"  v-if="Calculated_response!=null">
                                                                                {{ Calculated_response.toLocaleString() }} FCFA
                                                                                </span>
                                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[4]') }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 2">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepContractant" aria-hidden="true" aria-labelledby="step-StepContractant" class="wizard-tab-container">
                                        <div v-if="isContractant">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.title') }}&nbsp;:</div>
                                                    <div class="justify-content-center row">
                                                        <div class="col-sm-5 field-radio field-radio-center">
                                                            <div class="btn-choice">
                                                                <input v-model="ContractantFields.Genre" value="homme" type="radio" id="monsieur" name="genre" class="field-input">
                                                                <label for="monsieur" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="ContractantFields.Genre" value="femme" type="radio" id="madame" name="genre" class="field-input" >
                                                                <label for="madame" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</label>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-1 field-radio field-radio-center">
                                                            
                                                        </div>
                                                        
                                                        <div class="col-sm-5 field-radio field-radio-center">
                                                            <div class="btn-choice">
                                                                <input v-model="ContractantFields.Situation" value="marié" type="radio" id="marie" name="situation" class="field-input" >
                                                                <label for="marie" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</label>
                                                            </div>
                                                            <div class="btn-choice">
                                                                <input v-model="ContractantFields.Situation" value="célibataire" type="radio" id="celibat" name="situation" class="field-input" >
                                                                <label for="celibat" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</label>
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_label') }}</label>
                                                                <input v-model="ContractantFields.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_placeholder')" id="nom_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="prenom_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_label') }}</label>
                                                                <input v-model="ContractantFields.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="date_naiss_contractant" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_placeholder')" id="date_naiss_contractant" @change="yearsDiffContractant()" v-model="ContractantFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_naiss_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_label') }}</label>
                                                                <input v-model="ContractantFields.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_placeholder')" id="lieu_naiss_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="profession_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_label') }}</label>
                                                                <input v-model="ContractantFields.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_placeholder')" id="profession_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="adresse_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_label') }}</label>
                                                                <input v-model="ContractantFields.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="telephone_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="ContractantFields.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="email_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_label') }}</label>
                                                                <input v-model="ContractantFields.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_placeholder')" id="email_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="cni_contractant" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="ContractantFields.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_placeholder')" id="cni_contractant" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="activeStep + 1 < formSteps.length -1" @click="ContractControl()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 3">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepAssure" aria-hidden="true" aria-labelledby="step-StepAssure" class="wizard-tab-container">
                                        <div v-if="isAssure">
                                            <div class="loan-group loan-group-0"> 
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_title') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <div class="field-checkbox">
                                                                <!-- <div class="field-label">
                                                                    Le contractant est l'assuré ?
                                                                </div> -->
                                                                <div class="switch">
                                                                    <label for="assur_question"><span class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_assure_title') }}</span>
                                                                    <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="assur_question" name="Step12">
                                                                    <span style="margin-top: 5px;" class="lever"></span>
                                                                    </label>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_label') }}</label>
                                                                <input v-model="AssureFields.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_placeholder')" id="nom_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="prenom_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_label') }}</label>
                                                                <input v-model="AssureFields.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_placeholder')" id="prenom_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="date_naiss_assure" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_placeholder')" id="date_naiss_assure" @change="yearsDiffAssure()" v-model="AssureFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_naiss_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_label') }}</label>
                                                                <input v-model="AssureFields.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_placeholder')" id="lieu_naiss_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="profession_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_label') }}</label>
                                                                <input v-model="AssureFields.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_placeholder')" id="profession_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="adresse_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_label') }}</label>
                                                                <input v-model="AssureFields.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_placeholder')" id="adresse_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="telephone_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="AssureFields.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_placeholder')" id="telephone_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="email_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.email_label') }}</label>
                                                                <input v-model="AssureFields.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.email_placeholder')" id="email_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_exercice_assure" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_label') }}</label>
                                                                <input v-model="AssureFields.LieuExe" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_placeholder')" id="lieu_exercice_assure" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToSecondStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="activeStep + 1 < formSteps.length -1" @click="AssureControl()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 4">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepBenef" aria-hidden="true" aria-labelledby="step-StepBenef" class="wizard-tab-container">
                                        <div v-if="isBenef">
                                            <div class="loan-group loan-group-0"> 
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_title') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="nom_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_label') }}</label>
                                                                <input v-model="BenefiFields.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_placeholder')" id="nom_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="prenom_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_label') }}</label>
                                                                <input v-model="BenefiFields.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_placeholder')" id="prenom_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="date_naiss_benef" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker disabled class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_placeholder')" id="date_naiss_benef" @change="yearsDiffBenef()" v-model="BenefiFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="lieu_naiss_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_label') }}</label>
                                                                <input v-model="BenefiFields.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_placeholder')" id="lieu_naiss_benef" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="filiation_benef" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_label') }}</label>
                                                                <select v-model="BenefiFields.Filiation" id="filiation_benef" name="Step8" class="field-select">
                                                                    <option></option>
                                                                    <option value="fils_fille">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.fille_label') }}</option>
                                                                    <option value="frere_soeur">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.frere_label') }}</option>
                                                                    <option value="neveu_niece">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.neveu_label') }}</option>
                                                                    <option value="cousin_e">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.cousin_label') }}</option>
                                                                    <option value="autres">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.autre_label') }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToThirstStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="activeStep + 1 < formSteps.length -1" @click="BenefControl()" type="button" class="wizard-btn">
                                                    {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 5">
                               <div class="wizard-tab-content">
                                    <div role="tabpanel" id="StepQuestionMedical" aria-hidden="true" aria-labelledby="step-StepQuestionMedical" class="wizard-tab-container">
                                        <div v-if="QuestionnaireSuite">
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.title') }}&nbsp;:</div>
                                                </div> 
                                                <div class="fields" v-if="QuestionNext.Q">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.principal_question') }}</div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_taille_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="question_0.resp_taille" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_taille_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_poid_label') }}</label>
                                                                <input @keypress="onlyNumber" v-model="question_0.resp_poid" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_poid_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <div v-if="QuestionNext.firstPage">
                                                    <div class="pb-3 fields" v-if="QuestionNext.Q1">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.principal_question') }}</div>
                                                            </div>
                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep2" v-model="question_1.principal_response" value="oui" type="radio" id="question_1_oui" name="question_1" class="field-input">
                                                                        <label for="question_1_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep2" v-model="question_1.principal_response" value="non" type="radio" id="question_1_non" name="question_1" class="field-input" >
                                                                        <label for="question_1_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_1.principal_response =='oui'">
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite()" v-model="question_1.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                    <label for="motif" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_motif_label') }}
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <textarea @keyup="QuestionControlSuiteStep2"  rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_motif_placeholder')" v-model="question_1.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="pt-3 pb-3" v-if="QuestionNext.Q2">
                                                        <v-divider></v-divider>
                                                    </div>

                                                    <div class="fields" v-if="QuestionNext.Q2">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.principal_question') }}</div>
                                                            </div>

                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep3" v-model="question_2.principal_response" value="oui" type="radio" id="question_2_oui" name="question_2" class="field-input">
                                                                        <label for="question_2_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep3" v-model="question_2.principal_response" value="non" type="radio" id="question_2_non" name="question_2" class="field-input" >
                                                                        <label for="question_2_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_2.principal_response =='oui'">
                                                            <div class="col-sm-4">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite2()" v-model="question_2.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-4" >
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_duree_total_label') }}</label>
                                                                    <input type="number" @keyup="QuestionControlSuiteStep3()" v-model="question_2.resp_duree" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_duree_total_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                </div>
                                                            </div>

                                                             <div class="col-sm-4">
                                                                <div class="field-group field-default">
                                                                    <label for="motif" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_label') }}
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <textarea @keyup="QuestionControlSuiteStep3()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_placeholder')" v-model="question_2.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>

                                                    <div class="pt-3 pb-3" v-if="QuestionNext.Q3">
                                                        <v-divider></v-divider>
                                                    </div>

                                                    <div class="fields" v-if="QuestionNext.Q3">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_3.principal_question') }}</div>
                                                            </div>

                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep4" v-model="question_3.principal_response" value="oui" type="radio" id="question_3_oui" name="question_3" class="field-input">
                                                                        <label for="question_3_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep4" v-model="question_3.principal_response" value="non" type="radio" id="question_3_non" name="question_3" class="field-input" >
                                                                        <label for="question_3_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_3.principal_response =='oui'">
                                                            <div class="col-sm-4">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_3.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite3()" v-model="question_3.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-4" >
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_3.input_duree_total_label') }}</label>
                                                                    <input type="number" @keyup="QuestionControlSuiteStep4()" v-model="question_3.resp_duree" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_duree_total_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                </div>
                                                            </div>

                                                             <div class="col-sm-4">
                                                                <div class="field-group field-default">
                                                                    <label for="motif" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_label') }}
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <textarea @keyup="QuestionControlSuiteStep4()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_placeholder')" v-model="question_3.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>

                                                    <div class="pt-3 pb-3" v-if="QuestionNext.Q4">
                                                        <v-divider></v-divider>
                                                    </div>

                                                    <div class="fields" v-if="QuestionNext.Q4">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.principal_question') }}</div>
                                                            </div>

                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep5" v-model="question_4.principal_response" value="oui" type="radio" id="question_4_oui" name="question_4" class="field-input">
                                                                        <label for="question_4_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep5" v-model="question_4.principal_response" value="non" type="radio" id="question_4_non" name="question_4" class="field-input" >
                                                                        <label for="question_4_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_4.principal_response =='oui'">
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite4()" v-model="question_4.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>

                                                             <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                    <label for="motif" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_motif_label') }}
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <textarea @keyup="QuestionControlSuiteStep5()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_motif_placeholder')" v-model="question_4.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>

                                                     <div class="pt-3 pb-3" v-if="QuestionNext.Q5">
                                                        <v-divider></v-divider>
                                                    </div>

                                                    <div class="fields" v-if="QuestionNext.Q5">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.principal_question') }}</div>
                                                            </div>

                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep6" v-model="question_5.principal_response" value="oui" type="radio" id="question_5_oui" name="question_5" class="field-input">
                                                                        <label for="question_5_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep6" v-model="question_5.principal_response" value="non" type="radio" id="question_5_non" name="question_5" class="field-input" >
                                                                        <label for="question_5_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_5.principal_response =='oui'">
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite5()" v-model="question_5.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_taux_pension_label') }}</label>
                                                                    <input type="number" @keyup="QuestionControlSuiteStep6()" v-model="question_5.resp_taux" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_taux_pension_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_5.principal_response =='oui'">
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                    <label for="motif" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_label') }}
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <textarea @keyup="QuestionControlSuiteStep6()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_placeholder')" v-model="question_5.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                    <label for="motif" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_pension_label') }}
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <textarea @keyup="QuestionControlSuiteStep6()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_pension_placeholder')" v-model="question_5.resp_justification_servie" id="motif" name="remarque" class="field-input"></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>

                                                    <div class="pt-3 pb-3" v-if="QuestionNext.Q6">
                                                        <v-divider></v-divider>
                                                    </div>

                                                    <div class="fields" v-if="QuestionNext.Q6">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.principal_question') }}</div>
                                                            </div>

                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep7" v-model="question_6.principal_response" value="oui" type="radio" id="question_6_oui" name="question_6" class="field-input">
                                                                        <label for="question_6_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="QuestionControlSuiteStep7" v-model="question_6.principal_response" value="non" type="radio" id="question_6_non" name="question_6" class="field-input" >
                                                                        <label for="question_6_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_6.principal_response =='oui'">
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite6()" v-model="question_6.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>

                                                            <div class="col-sm-6" >
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_combien_label') }}</label>
                                                                    <input type="number" @keyup="QuestionControlSuiteStep7()" v-model="question_6.resp_combien" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_combien_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>

                                                    <div class="pt-3 pb-3" v-if="QuestionNext.Q7">
                                                        <v-divider></v-divider>
                                                    </div>

                                                    <div class="fields" v-if="QuestionNext.Q7">
                                                        <div class="row">
                                                            <div class="col-sm-8">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_7.principal_question') }}</div>
                                                            </div>

                                                            <div class="col-sm-4">
                                                                <div class="col-sm-12 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input @change="validField()" v-model="question_7.principal_response" value="oui" type="radio" id="question_7_oui" name="question_7" class="field-input">
                                                                        <label for="question_7_oui" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input @change="validField()" v-model="question_7.principal_response" value="non" type="radio" id="question_7_non" name="question_7" class="field-input" >
                                                                        <label for="question_7_non" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row" v-if="question_7.principal_response =='oui'">
                                                            <div class="col-sm-6">
                                                                <div class="field-group field-default">
                                                                <label for="Stepper25" class="field-label">
                                                                    {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_7.input_date_label') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_7.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite7()" v-model="question_7.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="wizard-card-footer clearfix mb-5" v-if="QuestionNext.Q">
                                                <div class="wizard-footer-left">
                                                    <button @click="returToFourStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="QuestionControlSuiteStep1()" type="button" class="wizard-btn">
                                                        {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>

                                             <div class="wizard-card-footer clearfix mb-5" v-if="QuestionNext.Q7">
                                                <div class="wizard-footer-left">
                                                    <button @click="QuestionControlSuiteBack6()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                    </button>
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button @click="validField()" type="button" class="wizard-btn">
                                                        {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 6">
                                <div class="wizard-tab-content">
                                <div role="tabpanel" id="StepRecap" aria-labelledby="step-StepRecap" class="wizard-tab-container">
                                    <div>
                                    <div class="fields">
                                        <section class="section-sm-bottom-85">
                                        <div class="container mt-1">
                                            <div class="row gx-xxl-6">
                                            <div class="col-12 col-lg-12">
                                                <div class="row">
                                                <div class="col-12">
                                                    <div class="post">
                                                    <div class="post-body">
                                                        <div>
                                                        <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                                            <div class="form">
                                                            <div class="page">
                                                                <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.validationStep.title') }} :</div>
                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.genre_label') }} :
                                                                                <span v-if="ContractantFields.Genre == 'homme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</span>
                                                                                <span v-if="ContractantFields.Genre == 'femme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.situation_label') }} :
                                                                                <span v-if="ContractantFields.Situation == 'marié'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</span>
                                                                                <span v-if="ContractantFields.Situation == 'célibataire'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</span>
                                                                                <span v-if="ContractantFields.Situation == 'veuf'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.veuf_label') }}</span>
                                                                                <span v-if="ContractantFields.Situation == 'divorce'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.divorce_label') }}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.date_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{DateFormater(ContractantFields.dateNaissance)}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.lieu_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.LieuNaissance}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.profession_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Profession}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.adresse_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Adresse}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.telephone_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Telephone}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.email_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ContractantFields.Email}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.date_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{DateFormater(AssureFields.dateNaissance)}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.lieu_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.LieuNaissance}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.profession_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.Profession}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.adresse_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.Adresse}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.telephone_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.Telephone}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.email_label') }} :
                                                                            <span class="font-weight-bold to-right">{{AssureFields.Email}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.title') }}</p>
                                                                    </div>
                                                                    </div>
                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.nom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{BenefiFields.Nom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.prenom_label') }} :
                                                                            <span class="font-weight-bold to-right">{{BenefiFields.Prenom}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.date_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{DateFormater(BenefiFields.dateNaissance)}}</span>
                                                                            </li>

                                                                            <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.lieu_naissance_label') }} :
                                                                            <span class="font-weight-bold to-right">{{BenefiFields.LieuNaissance}}</span>
                                                                            </li>

                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.filiation_label') }} :
                                                                                <span v-if="BenefiFields.Filiation == 'fils_fille'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.fille_label') }}</span>
                                                                                <span v-if="BenefiFields.Filiation == 'frere_soeur'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.frere_label') }}</span>
                                                                                <span v-if="BenefiFields.Filiation == 'neveu_niece'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.neveu_label') }}</span>
                                                                                <span v-if="BenefiFields.Filiation == 'cousin_e'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.cousin_label') }}</span>
                                                                                <span v-if="BenefiFields.Filiation == 'autres'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.autre_label') }}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row" style="margin-top: -10px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                                    <div class="col-sm-12">
                                                                        <div class="field-group field-default">
                                                                        <ul class="to-left mb-3 mr-3 policeLato">
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.duree_label') }} :
                                                                            <span class="font-weight-bold to-right">{{duree}} {{ $t('devis.devis_vie.sunuassur.validationStep.garantie.annee_label') }}</span>
                                                                            </li>
                                                                            <li v-show="Mensualite" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.capital_terme_label') }} :
                                                                            <span class="font-weight-bold to-right" v-if="Calculated_response != null">{{Calculated_response.toLocaleString()}} FCFA</span>
                                                                            </li>

                                                                            <li v-show="Mensualite" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.prime_mensuel_label') }} :
                                                                            <span class="font-weight-bold to-right" v-if="Calculated_response != null">{{choixCapital.Mensuel}} FCFA</span>
                                                                            </li>

                                                                            <li v-show="Capital" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.capital_terme_label') }} :
                                                                            <span class="font-weight-bold to-right" v-if="this.isCapital == true">{{choixCapital.Capital}} FCFA</span>
                                                                            <span class="font-weight-bold to-right" v-if="this.isRente == true">{{Capi.toLocaleString()}} FCFA</span>
                                                                            </li>

                                                                            <li v-show="Capital" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.prime_mensuel_label') }} :
                                                                            <span class="font-weight-bold to-right">{{monthly_payment}} FCFA</span>
                                                                            </li>

                                                                            <li v-show="Mensualite" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.rente_annuelle_label') }} :
                                                                            <span class="font-weight-bold to-right" v-if="Calculated_response != null">{{Mensu.toLocaleString()}} FCFA</span>
                                                                            </li>
                                                                            <li v-show="Capital" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.rente_annuelle_label') }} :
                                                                            <span class="font-weight-bold to-right" v-if="this.isCapital == true">{{Capi.toLocaleString()}} FCFA</span>
                                                                            <span class="font-weight-bold to-right" v-if="this.isRente == true">{{choixCapital.Capital}} FCFA</span>
                                                                            </li>
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.branche_label') }} :
                                                                            <span class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.branche_vie') }}</span>
                                                                            </li>
                                                                            <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.assureur_label') }} :
                                                                            <span class="font-weight-bold to-right">{{Assureur}}</span>
                                                                            </li>
                                                                        </ul>
                                                                        </div>
                                                                    </div>
                                                                    </div>

                                                                    <div class="mt-3 justify-content-center row">
                                                                    <div class="justify-content-center row">
                                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.title') }}</p>
                                                                    </div>
                                                                    </div>

                                                                    <div class="row">
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_effet') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6">
                                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                                <div class="wizard-card-footer clearfix mb-3">
                                                                <div class="wizard-footer-left">
                                                                    <!-- <button type="button" class="wizard-btn">
                                                                    <span class="fas fa-arrow-left"></span>
                                                                    Retour
                                                                    </button> -->
                                                                </div>
                                                                <div class="wizard-footer-right">
                                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                                        {{ $t('devis.devis_vie.sunuassur.bouton_valider_label') }}
                                                                    </button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </section>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs>
                    <div class="mt-5" style="background:#FAFAFA">
                    <div class="row" style="background:#FAFAFA">

                        <div class="col-md-10" style="background:#FAFAFA">
                            <div class="form" style="background:#FAFAFA">
                                <div class="page" v-show="step === 1">
                                    <div class="wizard-tab-content">
                                        <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                                            <div>
                                            <div class="fields">
                                                <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                        <div class="btn-choice">
                                                            <input @click="switchCapital" v-model="choix" value="capital" type="radio" id="capital_mobile" name="offre_mobile" class="field-input">
                                                            <label for="capital_mobile" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.bouton_capital_label') }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 field-radio field-radio-center mt-3">
                                                        <div class="btn-choice">
                                                            <input @click="switchMensuel" v-model="choix" value="mensuel" type="radio" id="mensualite_mobile" name="offre_mobile" class="field-input" >
                                                            <label for="mensualite_mobile" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.bouton_mensualite_label') }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 field-radio field-radio-center mt-3">
                                                        <div class="btn-choice">
                                                            <input @click="switchRente" v-model="choix" value="rente" type="radio" id="rente_mobile" name="offre_mobile" class="field-input" >
                                                            <label for="rente_mobile" class="field-label btn-choice-hide-dot">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.bouton_rente_label') }}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-show="Capital">
                                            <div class="loan-group loan-group-0" style="z-index:0!important">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.firstStep.titre_stepr_1') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="date_naissance_assure_mobile" class="field-label">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.date_naissance_assure_label') }}
                                                                <!---->
                                                            </label>
                                                            <div class="input-group value-loan">
                                                                <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_assure_mobile" @change="yearsDiff()" v-model="dateNaiss" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="date_naissance_benef_mobile" class="field-label">
                                                                {{$t('devis.devis_vie.sunuassur.firstStep.date_naissance_beneficiaire_label')}}
                                                                <!---->
                                                            </label>
                                                            <div class="input-group value-loan">
                                                                <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_benef_mobile" @change="yearsDiffBenef()" v-model="BenefiFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12" >
                                                                <div class="field-group field-default mb-4 mb-sm-0" v-if="isCapital">
                                                                    <label for="capital_souhaite_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.capital_souhaite_label') }}</label>
                                                                    <input v-money="money" @keyup="CheckFieldChange()" v-model="choixCapital.Capital" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.capital_souhaite_placeholder')" id="capital_souhaite_mobile" name="Step8" class="field-input">
                                                                </div>
                                                                <div class="field-group field-default mb-4 mb-sm-0" v-if="isRente">
                                                                    <label for="rente_souhaite_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.rente_souhaite_label') }}</label>
                                                                    <input v-money="money" @keyup="CheckFieldChange()" v-model="choixRente" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.rente_souhaite_placeholder')" id="rente_souhaite_mobile" name="Step8" class="field-input">
                                                                </div>
                                                        </div>
                                                       <!-- <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_capital_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                                <input @change="CheckFieldChange()" v-model="duree" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.duree_placeholder')" id="duree_capital_mobile" name="Step8" class="field-input">
                                                            </div>
                                                        </div>-->
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="duree_capital_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                                <select @change="CheckFieldChange()" v-model="duree" id="duree_capital_mobile" name="Step8_mobile" class="field-select">
                                                                    <option value="null" selected disabled>{{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.nombre_annee') }}</option>
                                                                    <option value="10">10 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="11">11 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="12">12 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="13">13 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="14">14 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="15">15 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="16">16 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="17">17 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="18">18 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="19">19 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                    <option value="20">20 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="fields" >
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="justify-content-center row" v-if="monthly_payment!=null">
                                                                <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                    <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_vie.sunuassur.firstStep.prime_mensuel_label') }}</div>
                                                                    <div class="field-title font-weight-bold text-center" style="color:#ffa409;margin-top:-10px">{{monthly_payment.toLocaleString()}} FCFA</div>

                                                                </div>
                                                            </div>
                                                            <div class="mb-3 text-center">
                                                                <p v-if="this.isCapital == true" class="font-weight-light" style="color: #5a5a5a">{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[0]') }} <span style="color: #DC143C">{{ Capi.toLocaleString() }} FCFA</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[1]') }} <span style="color: #DC143C">1</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[2]') }}
                                                                    <br>
                                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[3]') }} <span style="color: #DC143C">{{ choixCapital.Capital }} FCFA </span>{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[4]') }}
                                                                </p>

                                                                <p v-if="this.isRente == true" class="font-weight-light" style="color: #5a5a5a">{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[0]') }} <span style="color: #DC143C">{{ choixCapital.Capital }} FCFA</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[1]') }} <span style="color: #DC143C">1</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[2]') }}
                                                                    <br>
                                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[3]') }} <span style="color: #DC143C">{{ Capi.toLocaleString() }} FCFA </span>{{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[4]') }}
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="wizard-card-footer clearfix mb-5">
                                                <div class="wizard-footer-left">
                                                </div>
                                                <div class="wizard-footer-right">
                                                    <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_simuler_label') }}
                                                    </button>
                                                    <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                        {{ $t('devis.devis_vie.sunuassur.bouton_suivant_label') }}
                                                    </button>
                                                </div>
                                                <!---->
                                            </div>
                                    </div>

                                    <div v-show="Mensualite">
                                        <div class="loan-group loan-group-0" style="z-index:0!important">
                                            <div class="fields">
                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.firstStep.bouton_mensualite_label') }}&nbsp;:</div>
                                            <div class="row">
                                            <div class="col-sm-6">
                                                <div class="field-group field-default">
                                                <label for="date_naissance_mensualite_mobile" class="field-label">
                                                    {{ $t('devis.devis_vie.sunuassur.firstStep.date_naissance_assure_label') }}
                                                    <!---->
                                                </label>
                                                <div class="input-group value-loan">
                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_naissance_mensualite_mobile" @change="yearsDiff()" v-model="dateNaiss" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="field-group field-default">
                                                <label for="date_benef_mensualite_mobile" class="field-label">
                                                    {{$t('devis.devis_vie.sunuassur.firstStep.date_naissance_beneficiaire_label')}}
                                                    <!---->
                                                </label>
                                                <div class="input-group value-loan">
                                                    <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.date_naissance_placeholder')" id="date_benef_mensualite_mobile" @change="yearsDiffBenef()" v-model="BenefiFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                            </div>
                                            <div class="fields">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="mensualite_souhaite_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.mensualite_souhaite_label') }}</label>
                                                            <input v-money="money" @keyup="CheckFieldChange()" v-model="choixCapital.Mensuel" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.mensualite_souhaite_placeholder')" id="mensualite_souhaite_mobile" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                  <!--  <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_mensualite_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                            <input @change="CheckFieldChange()" v-model="duree" :placeholder="$t('devis.devis_vie.sunuassur.firstStep.duree_placeholder')" id="duree_mensualite_mobile" name="Step8" class="field-input">
                                                        </div>
                                                    </div>-->

                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="duree_mensualite_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.firstStep.duree_label') }}</label>
                                                            <select @change="CheckFieldChange()" v-model="duree" id="duree_mensualite_mobile" name="Step8_mobile" class="field-select">
                                                                <option value="null" selected disabled>{{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.nombre_annee') }}</option>
                                                                <option value="10">10 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="11">11 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="12">12 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="13">13 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="14">14 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="15">15 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="16">16 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="17">17 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="18">18 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="19">19 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                                <option value="20">20 {{ $t('devis.devis_vie.sunuassur.firstStep.duree_cotisation_select.an') }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="fields" >
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="justify-content-center row" v-if="Calculated_response!=null">
                                                            <div class="mt-5 mb-3 justify-content-center column" style="width: 250px">
                                                                <div class="field-title font-weight-bold text-center">{{ $t('devis.devis_vie.sunuassur.firstStep.capital_terme_label') }}</div>
                                                                <div class="field-title font-weight-bold text-center" style="color:#ffa409">{{Calculated_response.toLocaleString()}} FCFA</div>

                                                            </div>
                                                        </div>
                                                        <div class="text-center">
                                                            <p class="font-weight-light" style="color: #5a5a5a">
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[0]') }}
                                                                <span style="color: #DC143C">
                                                                            {{ Mensu.toLocaleString() }} FCFA
                                                                            </span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[1]') }} <span style="color: #DC143C">1</span> {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[2]') }}
                                                                <br>
                                                                {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[3]') }}
                                                                <span style="color: #DC143C"  v-if="Calculated_response!=null">
                                                                            {{ Calculated_response.toLocaleString() }} FCFA
                                                                            </span>
                                                                            {{ $t('devis.devis_vie.sunuassur.firstStep.text_explicatif_label[4]') }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wizard-card-footer clearfix mb-5">
                                            <div class="wizard-footer-left">
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button v-if="Simule" @click="fieldsControl()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_vie.sunuassur.bouton_simuler_label') }}
                                                </button>
                                                <button v-if="SkipSimule" @click="DevisNextStep()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_vie.sunuassur.bouton_simuler_label') }}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 2">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isContractant">
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.title') }}&nbsp;:</div>
                                                            <div class="justify-content-center row">
                                                                <div class="col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Genre" value="homme" type="radio" id="monsieur_mobile" name="genre_mobile" class="field-input">
                                                                        <label for="monsieur_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Genre" value="femme" type="radio" id="madame_mobile" name="genre_mobile" class="field-input" >
                                                                        <label for="madame_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</label>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="mt-3 col-sm-5 field-radio field-radio-center">
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Situation" value="marié" type="radio" id="marie_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="marie_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</label>
                                                                    </div>
                                                                    <div class="btn-choice">
                                                                        <input v-model="ContractantFields.Situation" value="célibataire" type="radio" id="celibat_mobile" name="situation_mobile" class="field-input" >
                                                                        <label for="celibat_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</label>
                                                                    </div>
                                                                </div>
                                                            
                                                            </div>
                                                        </div>

                                                        <div class="fields">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_label') }}</label>
                                                                        <input v-model="ContractantFields.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.nom_placeholder')" id="nom_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_label') }}</label>
                                                                        <input v-model="ContractantFields.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.prenom_placeholder')" id="prenom_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="date_naiss_contractant_mobile" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_label') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.date_naissance_placeholder')" id="date_naiss_contractant_mobile" @change="yearsDiffContractant()" v-model="ContractantFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_naiss_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_label') }}</label>
                                                                        <input v-model="ContractantFields.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.lieu_naissance_placeholder')" id="lieu_naiss_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="profession_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_label') }}</label>
                                                                        <input v-model="ContractantFields.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.profession_placeholder')" id="profession_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="adresse_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_label') }}</label>
                                                                        <input v-model="ContractantFields.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.adresse_placeholder')" id="adresse_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="telephone_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_label') }}</label>
                                                                        <input @keypress="onlyNumber" v-model="ContractantFields.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.telephone_placeholder')" id="telephone_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="email_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_label') }}</label>
                                                                        <input v-model="ContractantFields.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.email_placeholder')" id="email_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="cni_contractant_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_label') }}</label>
                                                                        <input @keypress="onlyNumber" v-model="ContractantFields.Cni" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.contractant_form.cni_placeholder')" id="cni_contractant_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToFirstStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button v-if="activeStep + 1 < formSteps.length -1" @click="ContractControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 3">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isAssure">
                                                    <div class="loan-group loan-group-0"> 
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_title') }}&nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <div class="field-checkbox">
                                                                        <!-- <div class="field-label">
                                                                            Le contractant est l'assuré ?
                                                                        </div> -->
                                                                        <div class="switch">
                                                                            <label for="assur_question"><span class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_assure_title') }}</span>
                                                                            <input style="margin-top:5px" @change="toggleCheckbox()" v-model="checkbox" type="checkbox" id="assur_question" name="Step12">
                                                                            <span style="margin-top: 5px;" class="lever"></span>
                                                                            </label>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="fields">
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_label') }}</label>
                                                                        <input v-model="AssureFields.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.nom_placeholder')" id="nom_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_label') }}</label>
                                                                        <input v-model="AssureFields.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.prenom_placeholder')" id="prenom_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="date_naiss_assure_mobile" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_label') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.date_naissance_placeholder')" id="date_naiss_assure_mobile" @change="yearsDiffAssure()" v-model="AssureFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_naiss_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_label') }}</label>
                                                                        <input v-model="AssureFields.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_naissance_placeholder')" id="lieu_naiss_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="profession_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_label') }}</label>
                                                                        <input v-model="AssureFields.Profession" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.profession_placeholder')" id="profession_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="adresse_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_label') }}</label>
                                                                        <input v-model="AssureFields.Adresse" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.adresse_placeholder')" id="adresse_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="telephone_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_label') }}</label>
                                                                        <input @keypress="onlyNumber" v-model="AssureFields.Telephone" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.telephone_placeholder')" id="telephone_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="email_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.email_label') }}</label>
                                                                        <input v-model="AssureFields.Email" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.email_placeholder')" id="email_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_exercice_assure_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_label') }}</label>
                                                                        <input v-model="AssureFields.LieuExe" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.assure_form.lieu_exercice_placeholder')" id="lieu_exercice_assure_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToSecondStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button v-if="activeStep + 1 < formSteps.length -1" @click="AssureControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                <div class="page" v-show="step === 4">
                                    <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                                <div v-if="isBenef">
                                                    <div class="loan-group loan-group-0"> 
                                                        <div class="fields">
                                                            <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_title') }}&nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="nom_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_label') }}</label>
                                                                        <input v-model="BenefiFields.Nom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.nom_placeholder')" id="nom_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="prenom_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_label') }}</label>
                                                                        <input v-model="BenefiFields.Prenom" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.prenom_placeholder')" id="prenom_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="date_naiss_benef_mobile" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_label') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <date-picker disabled class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.date_naissance_placeholder')" id="date_naiss_benef_mobile" @change="yearsDiffBenef()" v-model="BenefiFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="lieu_naiss_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_label') }}</label>
                                                                        <input v-model="BenefiFields.LieuNaissance" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.benef_form.lieu_naissance_placeholder')" id="lieu_naiss_benef_mobile" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="filiation_benef_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_label') }}</label>
                                                                        <select v-model="BenefiFields.Filiation" id="filiation_benef_mobile" name="Step8" class="field-select">
                                                                            <option></option>
                                                                            <option value="fils_fille">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.fille_label') }}</option>
                                                                            <option value="frere_soeur">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.frere_label') }}</option>
                                                                            <option value="neveu_niece">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.neveu_label') }}</option>
                                                                            <option value="cousin_e">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.cousin_label') }}</option>
                                                                            <option value="autres">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.autre_label') }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="wizard-card-footer clearfix mb-5">
                                                        <div class="wizard-footer-left">
                                                            <button @click="returToThirstStep()" type="button" class="wizard-btn">
                                                            <span class="fas fa-arrow-left"></span>
                                                            {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                            </button>
                                                        </div>
                                                        <div class="wizard-footer-right">
                                                            <button v-if="activeStep + 1 < formSteps.length -1" @click="BenefControl()" type="button" class="wizard-btn">
                                                                {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                            </button>
                                                        </div>
                                                        <!---->
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>

                                 <div class="page" v-show="step === 5">
                                    <div class="wizard-tab-content">
                                        <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                            <div v-if="QuestionnaireSuite">
                                                <div class="loan-group loan-group-0">
                                                    <div class="fields">
                                                        <div class="field-title font-weight-bold">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.title') }}&nbsp;:</div>
                                                    </div> 
                                                    <div class="fields" v-if="QuestionNext.Q">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.principal_question') }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_taille_label') }}</label>
                                                                    <input @keypress="onlyNumber" v-model="question_0.resp_taille" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_taille_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12">
                                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_poid_label') }}</label>
                                                                    <input @keypress="onlyNumber" v-model="question_0.resp_poid" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_0.input_poid_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div v-if="QuestionNext.firstPage">
                                                        <div class="fields" v-if="QuestionNext.Q1">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.principal_question') }}</div>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep2" v-model="question_1.principal_response" value="oui" type="radio" id="question_1_oui_mobile" name="question_1_mobile" class="field-input">
                                                                            <label for="question_1_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep2" v-model="question_1.principal_response" value="non" type="radio" id="question_1_non_mobile" name="question_1_mobile" class="field-input" >
                                                                            <label for="question_1_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_1.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite()" v-model="question_1.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="motif" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_motif_label') }}
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <textarea @keyup="QuestionControlSuiteStep2"  rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_1.input_motif_placeholder')" v-model="question_1.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="pt-3 pb-3" v-if="QuestionNext.Q2">
                                                            <v-divider></v-divider>
                                                        </div>

                                                        <div class="fields" v-if="QuestionNext.Q2">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.principal_question') }}</div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep3" v-model="question_2.principal_response" value="oui" type="radio" id="question_2_oui_mobile" name="question_2_mobile" class="field-input">
                                                                            <label for="question_2_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep3" v-model="question_2.principal_response" value="non" type="radio" id="question_2_non_mobile" name="question_2_mobile" class="field-input" >
                                                                            <label for="question_2_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_2.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite2()" v-model="question_2.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_duree_total_label') }}</label>
                                                                        <input type="number" @keyup="QuestionControlSuiteStep3()" v-model="question_2.resp_duree" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_duree_total_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="motif" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_label') }}
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <textarea @keyup="QuestionControlSuiteStep3()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_placeholder')" v-model="question_2.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>

                                                        <div class="pt-3 pb-3" v-if="QuestionNext.Q3">
                                                            <v-divider></v-divider>
                                                        </div>

                                                        <div class="fields" v-if="QuestionNext.Q3">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_3.principal_question') }}</div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep4" v-model="question_3.principal_response" value="oui" type="radio" id="question_3_oui_mobile" name="question_3_mobile" class="field-input">
                                                                            <label for="question_3_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep4" v-model="question_3.principal_response" value="non" type="radio" id="question_3_non_mobile" name="question_3_mobile" class="field-input" >
                                                                            <label for="question_3_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_3.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_3.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite3()" v-model="question_3.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12" >
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_3.input_duree_total_label') }}</label>
                                                                        <input type="number" @keyup="QuestionControlSuiteStep4()" v-model="question_3.resp_duree" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_duree_total_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="motif" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_label') }}
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <textarea @keyup="QuestionControlSuiteStep4()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_2.input_motif_placeholder')" v-model="question_3.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>

                                                        <div class="pt-3 pb-3" v-if="QuestionNext.Q4">
                                                            <v-divider></v-divider>
                                                        </div>

                                                        <div class="fields" v-if="QuestionNext.Q4">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.principal_question') }}</div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep5" v-model="question_4.principal_response" value="oui" type="radio" id="question_4_oui_mobile" name="question_4_mobile" class="field-input">
                                                                            <label for="question_4_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep5" v-model="question_4.principal_response" value="non" type="radio" id="question_4_non_mobile" name="question_4_mobile" class="field-input" >
                                                                            <label for="question_4_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_4.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite4()" v-model="question_4.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="motif" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_motif_label') }}
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <textarea @keyup="QuestionControlSuiteStep5()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_4.input_motif_placeholder')" v-model="question_4.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>

                                                        <div class="pt-3 pb-3" v-if="QuestionNext.Q5">
                                                            <v-divider></v-divider>
                                                        </div>

                                                        <div class="fields" v-if="QuestionNext.Q5">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.principal_question') }}</div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep6" v-model="question_5.principal_response" value="oui" type="radio" id="question_5_oui_mobile" name="question_5_mobile" class="field-input">
                                                                            <label for="question_5_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep6" v-model="question_5.principal_response" value="non" type="radio" id="question_5_non_mobile" name="question_5_mobile" class="field-input" >
                                                                            <label for="question_5_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_5.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite5()" v-model="question_5.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_taux_pension_label') }}</label>
                                                                        <input type="number" @keyup="QuestionControlSuiteStep6()" v-model="question_5.resp_taux" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_taux_pension_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="motif" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_label') }}
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <textarea @keyup="QuestionControlSuiteStep6()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_placeholder')" v-model="question_5.resp_justification" id="motif" name="remarque" class="field-input"></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="motif" class="field-label">
                                                                            {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_pension_label') }}
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <textarea @keyup="QuestionControlSuiteStep6()" rows="4" cols="50" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_5.input_motif_pension_placeholder')" v-model="question_5.resp_justification_servie" id="motif" name="remarque" class="field-input"></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>

                                                        <div class="pt-3 pb-3" v-if="QuestionNext.Q6">
                                                            <v-divider></v-divider>
                                                        </div>

                                                        <div class="fields" v-if="QuestionNext.Q6">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.principal_question') }}</div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep7" v-model="question_6.principal_response" value="oui" type="radio" id="question_6_oui_mobile" name="question_6_mobile" class="field-input">
                                                                            <label for="question_6_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="QuestionControlSuiteStep7" v-model="question_6.principal_response" value="non" type="radio" id="question_6_non_mobile" name="question_6_mobile" class="field-input" >
                                                                            <label for="question_6_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_6.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite6()" v-model="question_6.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper28" class="field-label">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_combien_label') }}</label>
                                                                        <input type="number" @keyup="QuestionControlSuiteStep7()" v-model="question_6.resp_combien" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_6.input_combien_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>

                                                        <div class="pt-3 pb-3" v-if="QuestionNext.Q7">
                                                            <v-divider></v-divider>
                                                        </div>

                                                        <div class="fields" v-if="QuestionNext.Q7">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <div class="field-title font-weight-bold" style="font-size: 18px;">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_7.principal_question') }}</div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="col-sm-12 field-radio field-radio-center">
                                                                        <div class="btn-choice">
                                                                            <input @change="validField()" v-model="question_7.principal_response" value="oui" type="radio" id="question_7_oui_mobile" name="question_7_mobile" class="field-input">
                                                                            <label for="question_7_oui_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.oui_label') }}</label>
                                                                        </div>
                                                                        <div class="btn-choice">
                                                                            <input @change="validField()" v-model="question_7.principal_response" value="non" type="radio" id="question_7_non_mobile" name="question_7_mobile" class="field-input" >
                                                                            <label for="question_7_non_mobile" class="field-label btn-choice-hide-dot">{{ $t('devis.devis_vie.sunuassur.secondStep.question_form.non_label') }}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="row" v-if="question_7.principal_response =='oui'">
                                                                <div class="col-sm-12">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                    <label for="Stepper25" class="field-label">
                                                                        {{ $t('devis.devis_vie.sunuassur.secondStep.question_form.question_7.input_date_label') }}
                                                                        <!---->
                                                                    </label>
                                                                    <div class="input-group value-loan">
                                                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.secondStep.question_form.question_7.input_date_placeholder')" id="Stepper25" @change="yearsDiffQuestionSuite7()" v-model="question_7.resp_date" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix mb-5" v-if="QuestionNext.Q">
                                                    <div class="wizard-footer-left">
                                                        <button @click="returToFourStep()" type="button" class="wizard-btn">
                                                        <span class="fas fa-arrow-left"></span>
                                                        {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                        </button>
                                                    </div>
                                                    <div class="wizard-footer-right">
                                                        <button @click="QuestionControlSuiteStep1()" type="button" class="wizard-btn">
                                                            {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                        </button>
                                                    </div>
                                                    <!---->
                                                </div>

                                                <div class="wizard-card-footer clearfix mb-5" v-if="QuestionNext.Q7">
                                                    <div class="wizard-footer-left">
                                                        <button @click="QuestionControlSuiteBack6()" type="button" class="wizard-btn">
                                                        <span class="fas fa-arrow-left"></span>
                                                        {{$t('devis.devis_vie.sunuassur.bouton_retour_label')}}
                                                        </button>
                                                    </div>
                                                    <div class="wizard-footer-right">
                                                        <button @click="validField()" type="button" class="wizard-btn">
                                                            {{$t('devis.devis_vie.sunuassur.bouton_suivant_label')}}
                                                        </button>
                                                    </div>
                                                    <!---->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="page review_page" v-show="step === 6">
                                    <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                                    <div role="tabpanel" id="devis_iAc" aria-labelledby="step-devis_iAc" class="wizard-tab-container">
                                        <div data-v-0d43d413="">
                                        <div data-v-0d43d413="" class="fields">
                                            <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                                {{ $t('devis.devis_vie.sunuassur.validationStep.title') }}e
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.genre_label') }} :
                                                            <span v-if="ContractantFields.Genre == 'homme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.monsieur_label') }}</span>
                                                            <span v-if="ContractantFields.Genre == 'femme'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.madame_label') }}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.situation_label') }} :
                                                            <span v-if="ContractantFields.Situation == 'marié'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.marie_label') }}</span>
                                                            <span v-if="ContractantFields.Situation == 'célibataire'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.celibat_label') }}</span>
                                                            <span v-if="ContractantFields.Situation == 'veuf'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.veuf_label') }}</span>
                                                            <span v-if="ContractantFields.Situation == 'divorce'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.contractant_form.divorce_label') }}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.Nom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.Prenom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.date_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{DateFormater(ContractantFields.dateNaissance)}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.lieu_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.LieuNaissance}}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.profession_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.Profession}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.adresse_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.Adresse}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.telephone_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.Telephone}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.contractant.email_label') }} :
                                                        <span class="font-weight-bold to-right">{{ContractantFields.Email}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.Nom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.Prenom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.date_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{DateFormater(AssureFields.dateNaissance)}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.lieu_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.LieuNaissance}}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.profession_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.Profession}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.adresse_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.Adresse}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.telephone_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.Telephone}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.assure.email_label') }} :
                                                        <span class="font-weight-bold to-right">{{AssureFields.Email}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div data-v-221edead="">
                                        <div data-v-221edead="" class="results-deals">
                                        <div data-v-221edead="" id="results-table">
                                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                                            <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                                <div data-v-221edead="" class="card-default-body">
                                                <h1 class="field-title row justify-content-center">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.title') }}</h1>
                                                <div data-v-221edead="" class="logo-company logo-company-economy">
                                                    <ul class="to-left mb-3 mr-3 policeLato">
                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.nom_label') }} :
                                                        <span class="font-weight-bold to-right">{{BenefiFields.Nom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.prenom_label') }} :
                                                        <span class="font-weight-bold to-right">{{BenefiFields.Prenom}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.date_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{DateFormater(BenefiFields.dateNaissance)}}</span>
                                                        </li>

                                                        <li class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.lieu_naissance_label') }} :
                                                        <span class="font-weight-bold to-right">{{BenefiFields.LieuNaissance}}</span>
                                                        </li>

                                                        <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.beneficiaire.filiation_label') }} :
                                                            <span v-if="BenefiFields.Filiation == 'fils_fille'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.fille_label') }}</span>
                                                            <span v-if="BenefiFields.Filiation == 'frere_soeur'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.frere_label') }}</span>
                                                            <span v-if="BenefiFields.Filiation == 'neveu_niece'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.neveu_label') }}</span>
                                                            <span v-if="BenefiFields.Filiation == 'cousin_e'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.cousin_label') }}</span>
                                                            <span v-if="BenefiFields.Filiation == 'autres'" class="font-weight-bold to-right">{{ $t('devis.devis_vie.sunuassur.secondStep.benef_form.filiation_select.autre_label') }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                    <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="mt-3 wizard-tab-container">
                                    <div data-v-0d43d413="">
                                    <div data-v-0d43d413="" class="fields">
                                        <div data-v-0d43d413="" class="font-weight-bold field-title mb-0 row justify-content-center">
                                            {{ $t('devis.devis_vie.sunuassur.validationStep.periode.title') }}
                                        </div>

                                        <div class="row">
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper39_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_effet') }}
                                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <date-picker id="Stepper39_mobile" :disabled-date="disabledAfterToday"  class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                            </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="field-group field-default mb-4 mb-sm-0">
                                            <label for="Stepper40_mobile" class="field-label">{{ $t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance') }}
                                                <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                            <div class="input-group rate-loan">
                                                <input disabled :placeholder="$t('devis.devis_vie.sunuassur.validationStep.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40_mobile" name="Step11" class="field-input">
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div class="fields">
                                        <div class="field-group row flex-column flex-sm-row">
                                            <div class="justify-content-center row ml-3 mr-3">
                                                <ul class="to-left mb-3 mr-3 policeLato">
                                                    <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.duree_label') }} :
                                                    <span class="font-weight-bold to-right">{{duree}} {{ $t('devis.devis_vie.sunuassur.validationStep.garantie.annee_label') }}</span>
                                                    </li>
                                                    <li v-show="Mensualite" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.capital_terme_label') }}:
                                                    <span class="font-weight-bold to-right" v-if="Calculated_response != null">{{Calculated_response.toLocaleString()}} FCFA</span>
                                                    </li>

                                                    <li v-show="Mensualite" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.prime_mensuel_label') }} :
                                                    <span class="font-weight-bold to-right" v-if="Calculated_response != null">{{choixCapital.Mensuel}} FCFA</span>
                                                    </li>

                                                    <li v-show="Capital" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.capital_terme_label') }}:
                                                    <span class="font-weight-bold to-right" v-if="this.isCapital == true">{{choixCapital.Capital}} FCFA</span>
                                                    <span class="font-weight-bold to-right" v-if="this.isRente == true">{{Capi.toLocaleString()}} FCFA</span>
                                                    </li>

                                                    <li v-show="Capital" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.prime_mensuel_label') }} :
                                                    <span class="font-weight-bold to-right">{{monthly_payment}} FCFA</span>
                                                    </li>

                                                    <li v-show="Mensualite" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.rente_annuelle_label') }} :
                                                    <span class="font-weight-bold to-right" v-if="Calculated_response != null">{{Mensu.toLocaleString()}} FCFA</span>
                                                    </li>
                                                    <li v-show="Capital" class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.rente_annuelle_label') }} :
                                                    <span class="font-weight-bold to-right" v-if="this.isCapital == true">{{Capi.toLocaleString()}} FCFA</span>
                                                    <span class="font-weight-bold to-right" v-if="this.isRente == true">{{choixCapital.Capital}} FCFA</span>
                                                    </li>
                                                    <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.branche_label') }} :
                                                    <span class="font-weight-bold to-right">{{ $t('devis.devis_vie.nsiaetude.validationStep.garantie.branche_vie') }}</span>
                                                    </li>
                                                    <li  class="subheading" style="list-style: none">{{ $t('devis.devis_vie.sunuassur.validationStep.garantie.assureur_label') }} :
                                                    <span class="font-weight-bold to-right">{{Assureur}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        </div>

                                    </div>
                                    </div>
                                </div>

                                  </div>

                                  <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        
                      </div>
                      <div class="wizard-footer-right">
                        <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                            {{ $t('devis.devis_vie.sunuassur.bouton_valider_label') }}
                        </button>
                      </div>
                      <!---->
                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        
        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_voyage.devis_encours')}}</span>
    </div>

        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
            <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                    <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_voyage.devis_encours')}}</span>
                        </div>
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import Api from '../services/Api'
    import store from '../store/store'
    import LoginForm from './auth/Login'
    import ville from './../common/ville'


    const validateEmail = email => {
        if (!email.length) {
            return {valide: false, error: "L'adresse mail est obligatoire!"};
        } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            return { valide: false, error: "Veuillez entrer un email valide!" };
        } else {
            return { valide: true, error: null };
        }
    };

    const validatePhone = phone => {

        if(!phone.length){
            return { valide: false, error: 'Le numéro de téléphone est obligatoire.' };
        }else if (phone.length < 9) {
            return { valide: false, error: 'Le numéro de téléphone doit contenir 9 chiffres au minimum.' };
        }else{
            return { valide: true, error: null };
        }

    };

    export default {
        name: 'Devis_sunuAssur',
        components: {
            LoginForm
        },
        data() {
            return {
                choix : 'capital',
                dialogLoading : false,
                disabledButtonValidate : false,
                step: 1,
                dateSouscription: new Date().toISOString().substr(0, 10),
                neant: 'N.A',
                date: new Date().toISOString().substr(0, 10),
                first_questionnaire : true,
                isCapital : true,
                isRente : false,
                choixRente : null,
                QuestionnaireTab:[],
                question_0:{
                    num:1,
                    principal_question:'Indiquer votre taille et votre poids ?',
                    resp_taille : '',
                    resp_poid : '',
                },
                question_1:{
                    num:2,
                    principal_question:'Etes-vous en arret de travail?',
                    resp_date : '',
                    principal_response:'',
                    resp_justification:''
                },
                question_2:{
                    num:3,
                    principal_question:'Au cours des 5 dernières années, avez-vous du interrompre votre travail plus de 30 jours consécutifs pour maladie ou accident?',
                    resp_date : '',
                    resp_duree : '',
                    principal_response:'',
                    resp_justification:''
                },
                question_3:{
                    num:4,
                    principal_question:'Avez-vous séjourné dans un établissement hospitalier (hôpital, clinique, maison de santé, etc...) au cours des dernières années ?',
                    resp_date : '',
                    resp_duree : '',
                    principal_response:'',
                    resp_justification:''
                },
                question_4:{
                    num:5,
                    principal_question:'Avez-vous subi des interventions chirurgicales, au cours des 5 dernières années?',
                    resp_date : '',
                    principal_response:'',
                    resp_justification:''
                },
                question_5:{
                    num:6,
                    principal_question:'Êtes-vous atteint d\'une infirmité, d\'une invalidité ou d\'une maladie chronique ?',
                    resp_date : '',
                    resp_taux: '',
                    resp_justification_servie: '',
                    principal_response:'',
                    resp_justification:''
                },
                question_6:{
                    num:7,
                    principal_question:'Avez-vous eu au cours des 3 dernières années des infections ou inflammations ganglionnaires inexpliquées ?',
                    resp_date : '',
                    principal_response:'',
                    resp_combien: '',
                    resp_justification:''
                },
                question_7:{
                    num:8,
                    principal_question:'Avez-vous eu au cours des 3 dernières années des infections chroniques des voies respiratoires ?',
                    resp_date : '',
                    principal_response:'',
                    resp_justification:''
                },
                oldDate : null,
                bottomPushNotif : false,
                disableDateAssure: true,
                Modalite : null,
                Assureur :'',
                Simule : true,
                SkipSimule : false,
                money:{
                    thousands: ' ',
                    precision: false,
                    masked: false,
                },
                choixOffre:null,
                choixOffreFinale: null,
                dateNaiss : null,
                duree : null,
                Capital:true,
                Mensualite: false,
                Capi_souhaite: null,
                rente_an: null,
                pourcent: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
                choixCapital:{
                    Capital: null,
                    Mensuel : null,
                },
                dateEffet: null,
                dateEcheance: null,
                e1: 1,
                elevation: 2,
                activeStep: 0,
                checkbox: false,
                errors: {},
                aStorMap: false,
                disable: false,
                valide: null,
                age: null,
                QuestionSwitch:{
                    Q1 : null,
                    Q2 : null,
                    Q3 : null,
                    Q4 : null,
                    Q5 : null,
                    Q6 : null,
                    Q7 : null,
                },
                QuestionNext: {
                    Q : true,
                    Q1 : false,
                    Q2 : false,
                    Q3 : false,
                    Q4 : false,
                    Q5 : false,
                    Q6 : false,
                    Q7 : false,
                    firstPage : false
                },

                // numTelephone : '' ,
                amenities: [1, 4],
                genre: null,

                fraisLiv: 0,
                fraisPaiement: 0,
                Testons: false,
                itemsGenre: ["Homme", "Femme"],
                adresselivraison: "",
                autoHeight: true,
                x: null,
                dialogAlert: false,
                Devis_pour_souscription: [],
                mode_livraison: null,
                listVille: ville,

                menuDelivrance: false,
                Calculated_response:null,
                monthly_payment:null,
                mode_payement: null,
                notifDeviParMail: null,
                countries: null,
                ville: null,
                quartier: "",
                listegaranties: [],
                marque: null,
                tableau_info_passager: [],
                nbPassager: null,
                frais_livraison: null,
                branche: null,
                continue_btn: false,
                dialogInfoPassager: false,
                dialog: false,
                city: null,
                datePickerDateNais: false,
                IsPaid: false,
                adresse: false,
                livePaper: false,
                checked : false,
                showLoginForm: false,
                animation: 'animate-in',
                NomAssure: null,
                isContractant: true,
                isAssure: false,
                isBenef: false,
                Questionnaire: false,
                QuestionnaireSuite : false,
                isPayment : false,
                menu: false,
                Capi : 0,
                Mensu: 0,
                ToastTabSucess: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: 'toasted-primary',
                    position: 'top-center',
                    duration: 4000,
                    fitToScreen: true,
                    type: 'error'
                }, // Customized options for error toast
                // Contractant fields
                ContractantFields: {
                    Cni: null,
                    Genre: null,
                    Situation: null,
                    Nom: null,
                    Prenom: null,
                    dateNaissance: null,
                    LieuNaissance: null,
                    Profession:  null,
                    Adresse: null,
                    Telephone: null,
                    Email: null
                },
                // Assure fields
                AssureFields: {
                    Nom: null,
                    Prenom: null,
                    dateNaissance: null,
                    LieuNaissance: null,
                    Profession:  null,
                    Adresse: null,
                    Telephone: null,
                    Email: null,
                    LieuExe: null,
                },
                // Beneficiaire fields
                BenefiFields:{
                    Nom: null,
                    Prenom: null,
                    dateNaissance: null,
                    LieuNaissance: null,
                    Filiation: '',
                },
                // Questionnaire fields
                QuestionsFieldsSuite:{
                    taille: null,
                    poids: null,
                    ArretTravailW: null,
                    ArretTravailM: null,
                    InterompTravailDate: null,
                    InterompTravailMotif: null,
                    InterompTravailDuree: null,
                    SejourDate: null,
                    SejourMotif: null,
                    SejourDuree: null,
                    interventionDate: null,
                    interventionMotif: null,
                    infirm: null,
                    infirmDate: null,
                    infirmTaux: null,
                    infirmServie: null,
                    infectionNbre: null,
                    infectionDate : null,
                    infectRespiratoire: null
                },

                formSteps: [
                    {
                        title: "CONTRACTANT",
                        fields: [
                                    { valid: true },
                                ]
                    },
                    {
                        title: "ASSURE",
                        fields: [
                            { valid: true },
                               ]
                    },
                    {
                        title: "BENEFICIAIRE",
                        fields: [
                            { valid: true },
                                ]
                    },
                    {
                        title: "QUESTIONNAIRE MEDICAL",
                        fields: [
                            { valid: true }
                        ]
                    },
                    {
                        title: "QUESTIONNAIRE MEDICAL SUITE",
                    }
                ],
                CreatedDevis:null,
            }
        },
        methods: {
            SetBeneficiarieToUpdate(item) {
                this.TheBeneficiarie = item
                this.editBeneficiarieDialog = true
            },

            UpdateBeneficiarie() 
            {
                const data = this.TheBeneficiarie
                if (data.nom != null && data.nom != "") 
                {
                    if (data.prenom != null && data.prenom != "") 
                    {
                    if (data.datenaissance != null && data.datenaissance != "") 
                    {
                        if (data.userid != null && data.userid != "") 
                        {
                        data.datenaissance = dayjs(data.datenaissance).format("YYYY-MM-DD")
                        data.id = data._id
                        Api().post("beneficiaries/update", data)
                            .then(resp => {
                            this.editBeneficiarieDialog = false
                            this.getBeneficiaries(data.userid)
                            if (resp.data.nModified == 1) {
                                this.$toasted.show('Le bénéficiaire a été mis à jour !', this.ToastTabSucess);
                            } else {
                                this.$toasted.show('Le mis à jour du bénéficiaire a échoué  !', this.ToastTabError);
                            }
                            }).catch((err) => {
                            console.log(err)
                            })
                        } else {

                        }
                    } else {
                        this.$toasted.show('La date de naissance du béneficiaire est obligatoire !', this.ToastTabError);
                    }
                    } else {
                    this.$toasted.show('Le prénom du béneficiaire est obligatoire !', this.ToastTabError);
                    }
                } else {
                    this.$toasted.show('Le nom du béneficiaire est obligatoire !', this.ToastTabError);
                }
            },

            DeleteBeneficiarie(item) {
            if (item._id && item._id != null && item._id != "") 
            {
                item.id = item._id
                Api().post("beneficiaries/delete", item)
                .then(resp => {
                    this.editBeneficiarieDialog = false
                    this.getBeneficiaries(item.userid)
                    if (resp.data.deletedCount == 1) {
                    this.$message.success('Le bénéficiaire a été supprimé !', this.AlertMessage)
                    } else {
                    this.$message.error('La suppression du bénéficiaire a échoué !', this.AlertMessage)
                    }
                }).catch((err) => {
                console.log(err)
                })
            }
        },

        getBeneficiaries(id) 
        {
            Api().post("beneficiaries/getone", { userid: id })
            .then((result) => {
                this.ListAssure = result.data.beneficiaries
                this.tableau_info_passager  = result.data.beneficiaries
                this.tab_perso  = result.data.beneficiaries
                this.nbAssureAdded = result.data.beneficiaries.length
                this.showValiderBtn = true;
            if (result.data.beneficiaries.length >= this.Devis_pour_souscription.details_pack_sante.assures.nombre_assures) {
                console.log("Existant")
                this.showPopUpBeneficiaireExistantSante = true
            } else {
                console.log("Non Existant")
                this.dialogInfoAssure = true
            }
            }).catch((err) => {
            console.log(err)
            });
        },

    async saveOneBeneficiaries(benef) {
      const benef_dt = {
        userid: benef.userid,
        nom: benef.nom,
        prenom: benef.prenom,
        genre: benef.age,
        datenaissance: benef.datenaissance,
        numero_cni: benef.numero_cni,
        pays: benef.pays,
        adresse: benef.adresse,
        telephone: benef.telephone,
        userid:benef.userid
      }
      const returner = await Api().post("beneficiaries/create", benef_dt)
      console.log(returner.data)
    },

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
            let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
            },
            /*================= retour à la premiere étape ==============*/
            returToFirstStep(){
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFirst');
                this.step = 1
            },
            returToSecondStep(){
                this.activeStep -= 1;
                this.isContractant = true,
                this.isAssure = false
                this.step = 2
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthSecond');
            },
             /*================= retour à la troisieme étape ==============*/
            returToThirstStep(){
                this.activeStep -= 1;
                this.isContractant = false,
                this.isAssure = true
                this.isBenef = false
                this.step = 3
                document.getElementById("testup").classList.remove('widthThirt');
            },
             /*================= retour à la quatrieme étape ==============*/
             returToFourStep(){
                this.activeStep -= 1;
                this.isContractant = false,
                this.isAssure = false
                this.isBenef = true
                this.Questionnaire = false
                this.step = 4
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFour');
            },
              //Date object formater to String
            DateFormater: function (TheDate) {
            if (TheDate) {
                return dayjs(TheDate).format('DD-MM-YYYY')
            }
            },
            disabledBeforeToday(date) {
              const today = dayjs(this.dateDepart).add(+1, 'day')
              return date < today;
            },
            disabledAfterToday(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date < today;
            },
            disabledAfterTodayBirth(date) {
              const today = dayjs(new Date()).add(-1, 'day')
              return date > today;
            },
         
            prev() {
                this.step--;
            },
            next() {
                this.step++;
            },









            /*On check le numero de la question dans le tableau avant de pusher*/
            CheckValue(numero)
            {
                let checker = 0
                for(let v of  this.QuestionnaireTab)
                {
                    if(v.num===numero){
                        checker = 1
                    }
                }
                return checker
            },

            switchRente(){
                this.Capital = true;
                this.Mensualite = false
                this.isCapital = false
                this.choixRente = null
                this.isRente = true
                if(this.isRente == true){
                    this.isCapital = false
                }else {
                    this.isCapital = true
                }
            },

            DynamicSimule(){
                if(this.Capital){
                    if(this.dateNaiss && this.choixCapital.Capital && this.duree){
                        this.fieldsControl()

                    } else {
                        this.bottomPushNotif = false;
                    }
                }else if(this.Mensualite){
                    if(this.dateNaiss && this.choixCapital.Mensuel && this.duree){
                        this.fieldsControl()
                    }else {
                        this.bottomPushNotif = false;
                    }
                }
                //this.Capi.replace
            },

            SwitchButtonColor(){
                $(".swith-click").click(function() {
                    $(".swith-click").removeClass('active');
                    $(this).addClass("active");
                });
            },

            CalculCapitalRente(){
                let capi = 0.1
                let capiForRente = 10
                if(this.isRente == true){
                    if(Number(this.choixRente.replace(/[^0-9.-]+/g, "")) >= 120000){
                        this.Capi = capiForRente * Number(this.choixRente.replace(/[^0-9.-]+/g, ""))
                    }else{
                        this.Capi = 0
                    }
                }else {
                    if(Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, "")) >= 120000){
                        this.Capi = capi * Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, ""))
                    }else{
                        this.Capi = 0
                    }
                }

                //this.CheckFieldChange()

            },
            CalculMensuRente(){
                let capi = 0.1 // 10%
                this.Mensu =  parseInt(capi * this.Calculated_response)
                console.log(':::::::::: rentre calculé option mensualité souhaité',this.Mensu)
            },
            /*========== Fonction pour faire choix entre capital ou mensualites ========*/
            Choix() {
                  if (this.Capital == true) {
                    this.choixOffreFinale = 'Capital';
                    this.choixCapital.Mensuel = null;
                } else if(this.Mensualite == true) {
                    this.choixCapital.Capital = null;
                    this.choixOffreFinale = 'Mensualite';
                    //this.SwitchButtonColor()


                }
                // if (this.choixOffre == this.Capital) {
                //     this.choixOffreFinale = 'Capital';
                //     this.choixCapital.Mensuel = null;
                // } else if(this.choixOffre == this.Mensualite) {
                //     this.choixCapital.Capital = null;
                //     this.choixOffreFinale = 'Mensualite';
                //     this.SwitchButtonColor()


                // }
            },

            /*===Send of data to API allowing create proposition for the customer===*/
            CreateDevis: function(){
                if (!store.state.isUserLoggedIn) {
                   this.showLoginForm = true
               } else {
                    if(this.dateEffet){
                        if(this.Capital){
                            if(this.isCapital == true){
                                const Sunu = {
                                    Contractant: this.ContractantFields,
                                    Assure: this.AssureFields,
                                    Beneficiaire : this.BenefiFields,
                                    Questionnaire : this.QuestionnaireTab,
                                    Modalite :this.Modalite,
                                    duree:this.duree,
                                    branche:'Vie',
                                    assureurs:'SUNU-VIE',
                                    userid: store.state.user._id,
                                    clientid: store.state.user._id,
                                    createur: store.state.user._id,
                                    dateEffet: this.dateEffet,
                                    dateEcheance: this.dateEcheance,
                                    dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                                    prime_mensuelle : this.monthly_payment,
                                    capital : Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, "")),
                                    duree_bourse:null,
                                    Rente : Number(this.Capi),
                                    plateforme:"Front",
                                    FuturPaiement : null,
                                };

                                this.disabledButtonValidate = true
                                this.dialogLoading = true;

                                Api().post('vie/create/devis', Sunu)
                                    .then((result) => {
                                        Api().get('devis/' + result.data.devis._id)
                                            .then(response => {
                                                document.getElementById("testup").classList.add('widthSixe');
                                                document.getElementById("fourStep").classList.add('checked');
                                                this.$store.dispatch('setDevisPayement', response.data);
                                                this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push('/payement') 
                                            })
                                    }).catch((err) => {
                                    console.log('error')
                                });
                            }else if(this.isRente == true){
                                const Sunu = {
                                    Contractant: this.ContractantFields,
                                    Assure: this.AssureFields,
                                    Beneficiaire : this.BenefiFields,
                                    Questionnaire : this.QuestionnaireTab,
                                    Modalite :this.Modalite,
                                    duree:this.duree,
                                    branche:'Vie',
                                    assureurs:'SUNU-VIE',
                                    userid: store.state.user._id,
                                    clientid: store.state.user._id,
                                    createur: store.state.user._id,
                                    dateEffet: this.dateEffet,
                                    dateEcheance: this.dateEcheance,
                                    dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                                    prime_mensuelle : this.monthly_payment,
                                    capital : Number(this.Capi),
                                    duree_bourse:null,
                                    plateforme:"Front",
                                    Rente : Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, "")),
                                    FuturPaiement : null,
                                };
                                 this.disabledButtonValidate = true
                                this.dialogLoading = true;

                                Api().post('vie/create/devis', Sunu)
                                    .then((result) => {
                                        Api().get('devis/' + result.data.devis._id)
                                            .then(response => {
                                                document.getElementById("testup").classList.add('widthSixe');
                                                document.getElementById("fourStep").classList.add('checked');
                                                this.$store.dispatch('setDevisPayement', response.data);
                                                this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push('/payement')
                                            })
                                    }).catch((err) => {
                                    console.log('error')
                                });
                            }
                        }
                        else if(this.Mensualite){
                            const Sunu = {
                                Contractant: this.ContractantFields,
                                Assure: this.AssureFields,
                                Beneficiaire : this.BenefiFields,
                                Questionnaire : this.QuestionsFieldsSuite,
                                Modalite :this.Modalite,
                                duree:this.duree,
                                branche:'Vie',
                                assureurs:'SUNU-VIE',
                                userid: store.state.user._id,
                                clientid: store.state.user._id,
                                createur: store.state.user._id,
                                dateEffet: this.dateEffet,
                                dateEcheance: this.dateEcheance,
                                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
                                prime_mensuelle : Number(this.choixCapital.Mensuel.replace(/[^0-9.-]+/g, "")),
                                capital : this.Calculated_response,
                                duree_bourse:null,
                                plateforme:"Front",
                                Rente :  Number(this.Mensu),
                                FuturPaiement : null
                            };
                             this.disabledButtonValidate = true
                                this.dialogLoading = true;

                            Api().post('vie/create/devis', Sunu)
                                .then((result) => {
                                    Api().get('devis/' + result.data.devis._id)
                                        .then(response => {
                                            document.getElementById("testup").classList.add('widthSixe');
                                            document.getElementById("fourStep").classList.add('checked');
                                            this.$store.dispatch('setDevisPayement', response.data);
                                            this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push('/payement')
                                        })
                                }).catch((err) => {
                                console.log('error')
                            });

                        }
                    }else {
                        this.$toasted.show( "Date d'effet obligatoire!", this.ToastTabError)
                    }

                  
               }
           },

            /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
            SendData: function () {
                this.bottomPushNotif = true
                const SimulateSunuData = {
                    age: this.dateNaiss,
                    duree: this.duree,
                    capital: Number(this.choixCapital.Mensuel.replace(/[^0-9.-]+/g, ""))
                };

                Api().post('vie/sunuassur/capital/calculation', SimulateSunuData)
                .then((res) => {
                    this.Calculated_response = res.data.capital
                    console.log(":::::::: CAPITAL RETOURNER PAR LAPI", this.Calculated_response)
                    this.CalculMensuRente()
                }).catch((err) => {
                    console.log(err)
                });
            },

            SendDataDeduction: function () {
                this.bottomPushNotif = true
                if(this.isRente == true){
                    const SimulateSunuData = {
                        age: this.dateNaiss,
                        duree: this.duree,
                        capital:Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, "")) * 10
                    };
                    //Api().post('sunuassur/capital/deduction', SimulateSunuData)
                    Api().post('vie/sunuassur/monthly/calculation', SimulateSunuData)
                        .then((res) => {
                            this.monthly_payment = res.data.monthly_payment
                            console.log(":::::::: MENSUALITE RETOURNER PAR LAPI", this.monthly_payment)
                            this.CalculCapitalRente()

                        }).catch((err) => {
                        console.log(err)
                    });
                }else {
                    const SimulateSunuData = {
                        age: this.dateNaiss,
                        duree: this.duree,
                        capital:Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, ""))
                    };
                    //Api().post('sunuassur/capital/deduction', SimulateSunuData)
                    Api().post('vie/sunuassur/monthly/calculation', SimulateSunuData)
                        .then((res) => {
                            this.monthly_payment = res.data.monthly_payment
                            this.CalculCapitalRente()

                        }).catch((err) => {
                        console.log(err)
                    });
                }

            },

            //Control des champs pour validation
            fieldsControl() {
                const date1 = dayjs(this.dateNaiss);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                let year = Math.floor(daydiff/360)

                this.Choix()
                let toDay = year
                if (this.dateNaiss) {
                    if(toDay > 65){
                        this.$toasted.show( "L'année de naissance doit être inferieur ou égale à 65 ans!", this.ToastTabError)
                    } else {
                        if (this.choixCapital.Capital || this.choixCapital.Mensuel)
                        {
                            if (this.choixOffreFinale == 'Capital'){
                                if(this.isRente == true){
                                    if(Number(this.choixRente.replace(/[^0-9.-]+/g, "")) < 120000) {
                                        this.$toasted.show( "La rente souhaitée doit être au minimum 120 000 FCFA!", this.ToastTabError)
                                    } else {
                                        if (this.duree) {
                                            if(this.duree >= 10) {
                                                if(this.duree > 20){
                                                    this.$toasted.show('Durée doit être inferieur à 20 ans! ', this.ToastTabError)
                                                }else {
                                                    let dureeTotal = Number(this.duree);
                                                    if(dureeTotal + toDay <= 65){
                                                        this.choixCapital.Capital = this.choixRente
                                                        this.SendDataDeduction()
                                                        this.SkipSimule = true
                                                        this.Simule = false
                                                        this.Modalite = 'CAPITAL SOUHAITÉ'
                                                        this.branche = 'vie'
                                                        this.Assureur = 'SUNU Assurance vie'
                                                    }else {
                                                        this.$toasted.show("Revoir la durée de cotisation. L’âge du contractant ne doit pas dépasser 65ans au terme du contrat", this.ToastTabError)
                                                    }
                                                }
                                            }else
                                            {
                                                this.$toasted.show('Durée doit être supérieur ou égale à 10 ans! ', this.ToastTabError)
                                            }
                                        } else {
                                            this.$toasted.show('Durée Obligtoire! ', this.ToastTabError)
                                        }
                                    }

                                }else if(this.isCapital == true){
                                    if(Number(this.choixCapital.Capital.replace(/[^0-9.-]+/g, "")) < 1200000) {
                                        this.$toasted.show( "Le capital souhaite doit être au minimum 1 200 000 FCFA!", this.ToastTabError)
                                    } else {
                                        if (this.duree) {
                                            if(this.duree >= 10) {
                                                if(this.duree > 20){
                                                    this.$toasted.show('Durée doit être inferieur à 20 ans! ', this.ToastTabError)
                                                }else {
                                                    let dureeTotal = Number(this.duree);
                                                    if(dureeTotal + toDay <= 65){

                                                        this.SendDataDeduction()
                                                        this.SkipSimule = true
                                                        this.Simule = false
                                                        this.Modalite = 'CAPITAL SOUHAITÉ'
                                                        this.branche = 'vie'
                                                        this.Assureur = 'SUNU Assurance vie'
                                                    }else {
                                                        this.$toasted.show("Revoir la durée de cotisation. L’âge du contractant ne doit pas dépasser 65ans au terme du contrat", this.ToastTabError)
                                                    }
                                                }
                                            }else
                                            {
                                                this.$toasted.show('Durée doit être supérieur ou égale à 10 ans! ', this.ToastTabError)
                                            }
                                        } else {
                                            this.$toasted.show('Durée Obligtoire! ', this.ToastTabError)
                                        }
                                    }
                                }

                            } else if(this.choixOffreFinale == 'Mensualite') {
                                if(Number(this.choixCapital.Mensuel.replace(/[^0-9.-]+/g, "")) < 10000)
                                {
                                    this.$toasted.show( "La mensualite souhaite doit être supérieur à 10 000 FCFA!", this.ToastTabError)
                                } else
                                {
                                    if (this.duree)
                                    {
                                        if(this.duree >= 10) {
                                            if(this.duree > 20){
                                                this.$toasted.show('Durée doit être inferieur à 20 ans! ', this.ToastTabError)
                                            }else {
                                                let dureeTotal = Number(this.duree);
                                                if(dureeTotal + toDay <= 65){
                                                    this.SendData()
                                                    this.Modalite = 'MENSUALITÉS SOUHAITÉES'
                                                    this.SkipSimule = true
                                                    this.Simule = false
                                                    this.branche = 'vie'
                                                    this.Assureur = 'SUNU Assurance vie'
                                                }else {
                                                    this.$toasted.show("Revoir la durée de cotisation. L’âge du contractant ne doit pas dépasser 65ans au terme du contrat", this.ToastTabError)
                                                }
                                            }
                                        }else {
                                            this.$toasted.show('Durée doit être supérieur ou égale à 10 ans! ', this.ToastTabError)
                                        }

                                    } else {
                                        this.$toasted.show('Durée Obligtoire! ', this.ToastTabError)
                                    }
                                }
                            }


                        } else {
                            this.$toasted.show("Capital obligatoire!", this.ToastTabError)
                        }
                    }

                } else {
                    this.$toasted.show('Année de naissance obligatoire! ', this.ToastTabError)
                }
            },

            CheckFieldChange(){
             /* if(this.dateNaiss = !this.dateNaiss){*/
                  this.Simule = true
                      this.SkipSimule = false
              /*}*/
                //this.DynamicSimule()
            },

            DevisNextStep(){
                const date1 = dayjs(this.BenefiFields.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                let year = Math.floor(daydiff/360)
                this.oldDate = this.dateNaiss

                let toDay = year
                let dureeTotal = Number(this.duree)
                if (this.choixOffreFinale == "Capital") {
                    if(this.monthly_payment >=10000){
                    if(this.BenefiFields.dateNaissance){
                        if(dureeTotal + toDay <= 21){
                            if (!store.state.isUserLoggedIn) {
                                this.showLoginForm = true
                            } else if(store.state.isUserLoggedIn){
                                this.ContractantFields.Nom = this.$store.state.user.nom
                                this.ContractantFields.Prenom = this.$store.state.user.prenom
                                this.ContractantFields.Telephone = this.$store.state.user.telephone_port
                                this.ContractantFields.Email = this.$store.state.user.email
                                this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
                                this.ContractantFields.Genre = this.$store.state.user.sexe
                                this.ContractantFields.Situation = this.$store.state.user.statut_marital
                                this.ContractantFields.Profession = this.$store.state.user.profession
                                this.ContractantFields.Adresse = this.$store.state.user.adresse
                                this.ContractantFields.Cni = this.$store.state.user.numero_piece
                                this.step = 2
                                this.ContractantFields.dateNaissance = this.dateNaiss
                                this.AssureFields.dateNaissance = this.dateNaiss
                                document.getElementById("testup").classList.add('widthFirst');
                                document.getElementById("firstStep").classList.add('checked');
                            }
                        }else {
                            this.$toasted.show("Revoir la durée de cotisation. L’âge du bénéficiaire ne doit pas dépasser 21 ans au terme du contrat", this.ToastTabError)
                        }
                    }else {
                        this.$toasted.show("Date bénéficiaire obligatoire !", this.ToastTabError)
                    }
                }else{
                    this.$toasted.show("La prime doit etre au minimum 10 000 FCFA !", this.ToastTabError)
                }
                }else if(this.choixOffreFinale == "Mensualite"){
                    if(this.BenefiFields.dateNaissance){
                        if(dureeTotal + toDay <= 21){
                            if (!store.state.isUserLoggedIn) {
                                this.showLoginForm = true
                            } else if(store.state.isUserLoggedIn){
                                this.ContractantFields.Nom = this.$store.state.user.nom
                                this.ContractantFields.Prenom = this.$store.state.user.prenom
                                this.ContractantFields.Telephone = this.$store.state.user.telephone_port
                                this.ContractantFields.Email = this.$store.state.user.email
                                this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
                                this.ContractantFields.Genre = this.$store.state.user.sexe
                                this.ContractantFields.Situation = this.$store.state.user.statut_marital
                                this.ContractantFields.Profession = this.$store.state.user.profession
                                this.ContractantFields.Adresse = this.$store.state.user.adresse
                                this.ContractantFields.Cni = this.$store.state.user.numero_piece
                                this.step = 2
                                this.ContractantFields.dateNaissance = this.dateNaiss
                                this.AssureFields.dateNaissance = this.dateNaiss
                                document.getElementById("testup").classList.add('widthFirst');
                                document.getElementById("firstStep").classList.add('checked');
                            }
                        }else {
                            this.$toasted.show("Revoir la durée de cotisation. L’âge du bénéficiaire ne doit pas dépasser 21 ans au terme du contrat", this.ToastTabError)
                        }
                    }else {
                        this.$toasted.show("Date bénéficiaire obligatoire !", this.ToastTabError)
                    }
               
                }
                




            },

            switchCapital(){
                this.Choix()
                this.Capital = true;
                this.Mensualite = false;
                this.Mensu= 0
                this.isCapital = true
                this.isRente = false
                this.choixRente = null
                this.ChoixCapital.Capital = null
                this.CheckFieldChange()
            },
            switchMensuel(){
                this.Choix()
                this.Mensualite = true;
                this.Capital = false;
                this.Capi= 0
                this.CheckFieldChange()
            },
            /*nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                }, 600);
            },*/
            toggleCheckbox() {
                if(this.checkbox == true){
                    this.AssureFields.Nom = this.ContractantFields.Nom
                    this.AssureFields.Prenom = this.ContractantFields.Prenom
                    this.AssureFields.dateNaissance = this.ContractantFields.dateNaissance
                    this.dateNaiss = this.ContractantFields.dateNaissance

                    //this.dateNaiss = this.ContractantFields.dateNaissance
                    this.AssureFields.LieuNaissance = this.ContractantFields.LieuNaissance
                    this.AssureFields.Profession = this.ContractantFields.Profession
                    this.AssureFields.Adresse = this.ContractantFields.Adresse
                    this.AssureFields.Telephone = this.ContractantFields.Telephone
                    this.AssureFields.Email = this.ContractantFields.Email
                    this.disableDateAssure = true
                    this.AssureControl()
                    this.DynamicSimule()
                }else if(this.checkbox == false){
                    //this.disableDateAssure = false
                    //this.dateNaiss = null
                    this.AssureFields.dateNaissance = this.oldDate
                    this.dateNaiss = this.oldDate
                    this.DynamicSimule()
                    //this.AssureFields.dateNaissance = this.dateNaiss
                    this.ClearForm()
                }
            },
            ClearForm: function () {
                this.AssureFields.Nom = null
                this.AssureFields.Prenom = null
                //this.AssureFields.dateNaissance = null
                this.AssureFields.LieuNaissance = null
                this.AssureFields.Profession = null
                this.AssureFields.Adresse = null
                this.AssureFields.Telephone = null
                this.AssureFields.Email = null
                this.AssureFields.LieuExe = null
            },
            yearsDiff(){
                const date1 = dayjs(this.dateNaiss).year();
                const date2 = new Date().getFullYear();
                let daydiff = date2 - date1
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.dateNaiss = null
                } else if (this.age) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas être Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }else if(this.age > 55){
                        this.$toasted.show( "L'année de naissance doit être inferieur ou égale à 55 ans!", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                else if (this.age<=0) {
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.dateNaiss = null
                    }
                }
                //this.CheckFieldChange()
            },

            yearsDiffContractant() {
                const date1 = dayjs(this.ContractantFields.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age <0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.ContractantFields.dateNaissance = null

                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.ContractantFields.dateNaissance = null
                    }
                }
                else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18 || this.age <= 0){
                        this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
                        this.ContractantFields.dateNaissance = null
                    }
                }
            },

            yearsDiffAssure() {
                const date1 = dayjs(this.AssureFields.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.AssureFields.dateNaissance = null


                } else if (this.age) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.AssureFields.dateNaissance = null
                    }
                }  else if (this.age<=0) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age < 18){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 18 ans! ", this.ToastTabError)
                        this.AssureFields.dateNaissance = null
                    }
                }

            },

            yearsDiffBenef() {
                const date1 = dayjs(this.BenefiFields.dateNaissance);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.BenefiFields.dateNaissance = null

                } else if (this.age >= 360) {
                    let year = Math.floor(this.age / 360);
                    this.age = year;
                    if(this.age > 11){
                        this.$toasted.show("Erreur, l'age doit pas etre Supérieur à 11 ans! ", this.ToastTabError)
                        this.BenefiFields.dateNaissance = null
                    }
                }
            },

            yearsDiffQuestionSuite() {
                const date1 = dayjs(this.question_1.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_1.resp_date = null

                }else {
                    this.QuestionControlSuiteStep2()
                }
            },

            yearsDiffQuestionSuite2() {
                const date1 = dayjs(this.question_2.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_2.resp_date = null

                }else {
                    this.QuestionControlSuiteStep3
                }
            },

            yearsDiffQuestionSuite3() {
                const date1 = dayjs(this.question_3.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_3.resp_date = null

                }else {
                    this.QuestionControlSuiteStep4()
                }
            },

            yearsDiffQuestionSuite4() {
                const date1 = dayjs(this.question_4.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_4.resp_date = null

                }else {
                    this.yearsDiffQuestionSuite5()
                }
            },

            yearsDiffQuestionSuite5() {
                const date1 = dayjs(this.question_5.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_5.resp_date = null

                }else {
                    this.QuestionControlSuiteStep6()
                }
            },

            yearsDiffQuestionSuite6() {
                const date1 = dayjs(this.question_6.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_6.resp_date = null

                }else {
                    this.QuestionControlSuiteStep7()
                }
            },

            yearsDiffQuestionSuite7() {
                const date1 = dayjs(this.question_7.resp_date);
                const date2 = dayjs(new Date().toISOString().substr(0, 10));
                let daydiff = date2.diff(date1, 'days');
                this.age = daydiff;

                if (this.age < 0) {
                    this.age = null;
                    this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
                    this.question_7.resp_date = null

                }
            },

            BackToStep1(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.step = 2;
                    this.activeStep -= 1;
                    this.isContractant = true,
                    this.isAssure = false
                }, 500);
            },

            BackToStep2(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.step = 3;
                    this.isContractant = false,
                        this.isAssure = true
                        this.isBenef = false
                }, 500);
            },

            BackToStep3(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                        this.isAssure = false
                    this.isBenef = true
                    this.Questionnaire = false
                }, 600);
            },
            BackToStep4(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 5;
                    this.isContractant = false,
                        this.isAssure = false
                    this.isBenef = false
                    this.Questionnaire = true
                    this.QuestionnaireSuite = false
                }, 600);
            },

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            dateDiff: function () {
                if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
                let inter = dayjs(this.dateEffet).add(this.duree, 'year').format('YYYY-MM-DD');
                this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            nextStep() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                    this.isAssure = true
                }, 600);
            },

            nextStep2() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =true
                }, 600);
            },

            nextStep3() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =false,
                        this.QuestionnaireSuite = true
                }, 600);
            },

            nextStep4() {
                this.animation = 'animate-out';
                setTimeout(() => {
                    this.animation = 'animate-in';
                    this.activeStep += 1;
                    this.isContractant = false,
                        this.isAssure = false,
                        this.isBenef =false,
                        this.QuestionnaireSuite = false
                        this.isPayment = true
                }, 600);
            },


            ContractControl() {
                this.errors = {}
                if(this.ContractantFields.Genre && this.ContractantFields.Situation){
                    if (this.ContractantFields.Nom && this.ContractantFields.Prenom) {
                        if(this.ContractantFields.dateNaissance && this.ContractantFields.LieuNaissance){
                            if(this.ContractantFields.Profession && this.ContractantFields.Adresse){
                                if(this.ContractantFields.Telephone && this.ContractantFields.Email){
                                    const validPhone = validatePhone(this.ContractantFields.Telephone);
                                    this.errors.phone = validPhone.error;

                                    const validEmail = validateEmail(this.ContractantFields.Email);
                                    this.errors.email = validEmail.error;
                                    if(validEmail.valide == true && validPhone.valide == true){
                                        if(this.ContractantFields.Cni){
                                            this.step = 3
                                            document.getElementById("testup").classList.add('widthSecond');
                                            document.getElementById("firstStep").classList.add('checked');
                                            this.nextStep();
                                        }else {
                                            this.$toasted.show('CNI obligatoire! ', this.ToastTabError)
                                            this.animation = 'animate-wrong';
                                            setTimeout(() => {
                                                this.animation = '';
                                            }, 400);
                                        }

                                    }
                                }else {
                                    this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                }
                            }else {
                                this.$toasted.show('Profession et Adresse obligatoires! ', this.ToastTabError)
                            }
                        }else {
                            this.$toasted.show('Date et Lieu de naissance obligatoires! ', this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                    }
                }else {
                    this.$toasted.show('Genre et Situation obligatoires! ', this.ToastTabError)
                }

            },

            AssureControl() {
                this.errors = {}
                if (this.AssureFields.Nom && this.AssureFields.Prenom) {
                    if(this.AssureFields.dateNaissance && this.AssureFields.LieuNaissance){
                        if(this.AssureFields.Profession && this.AssureFields.Adresse){
                            if(this.AssureFields.Telephone && this.AssureFields.Email){
                                const validPhone = validatePhone(this.AssureFields.Telephone);
                                this.errors.phone = validPhone.error;

                                const validEmail = validateEmail(this.AssureFields.Email);
                                this.errors.email = validEmail.error;
                                if(validEmail.valide == true && validPhone.valide == true){
                                    if(this.AssureFields.LieuExe){
                                        this.step = 4
                                        document.getElementById("testup").classList.add('widthThirt');
                                        document.getElementById("firstStep").classList.add('checked');
                                        this.nextStep2();
                                    }else {
                                        this.$toasted.show("Lieu d'exercice obligatoire! ", this.ToastTabError)
                                    }
                                }
                            }else {
                                this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
                                this.animation = 'animate-wrong';
                                setTimeout(() => {
                                    this.animation = '';
                                }, 400);
                            }
                        }else {
                            this.$toasted.show('Profession et Adresse obligatoires! ', this.ToastTabError)
                        }
                    }else {
                        this.$toasted.show('Date et Lieu de naissance obligatoires! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                }
            },

            BenefControl() {
                if (this.BenefiFields.Nom && this.BenefiFields.Prenom) {
                    if(this.BenefiFields.dateNaissance && this.BenefiFields.LieuNaissance){
                        if(this.BenefiFields.Filiation){
                            this.step = 5
                            document.getElementById("testup").classList.add('widthFour');
                            document.getElementById("secondStep").classList.add('checked');
                            this.nextStep3()
                        }else{
                            this.$toasted.show('Filiation obligatoire! ', this.ToastTabError)
                        }

                    }else {
                        this.$toasted.show('Date et Lieu de naissance obligatoires! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
                }
            },


            QuestionControlSuiteStep1() {
                if(this.question_0.resp_taille && this.question_0.resp_poid){
                    this.QuestionNext.Q = false
                    this.QuestionNext.Q1 = true
                    this.QuestionNext.firstPage = true
                }else {
                    this.$toasted.show("champs obligatoires! ", this.ToastTabError)
                }
                this.QuestionnaireTab.push(this.question_0)
            },

            QuestionControlSuiteStep2() {
                if(this.question_1.principal_response == 'oui'){
                    if(this.question_1.resp_date !== '' && this.question_1.resp_justification !== ''){
                        this.QuestionNext.Q2 = true
                        if(this.CheckValue(this.question_1.num)==0)
                        {
                            this.QuestionnaireTab.push(this.question_1)
                        }

                    }else{
                        this.QuestionNext.Q2 = false
                    }
                }else if(this.question_1.principal_response == 'non') {
                    this.QuestionNext.Q2 = true
                    this.question_1.resp_date = ''
                    this.question_1.resp_justification = ''
                    this.QuestionnaireTab.push(this.question_1)
                }

            },

            QuestionControlSuiteStep3() {
                if(this.question_2.principal_response == 'oui'){
                    if (this.question_2.resp_date !=='' && this.question_2.resp_justification !=='' && this.question_2.resp_duree !=='') {
                        this.QuestionNext.Q3 = true
                        if(this.CheckValue(this.question_2.num)==0)
                        {
                            this.QuestionnaireTab.push(this.question_2)
                        }
                    }else {
                        this.QuestionNext.Q3 = false
                    }
                }else if(this.question_2.principal_response == 'non') {
                    this.QuestionNext.Q3 = true
                    this.question_2.resp_date = ''
                    this.question_2.resp_justification = ''
                    this.question_2.resp_duree = ''
                    this.QuestionnaireTab.push(this.question_2)

                }
            },

            QuestionControlSuiteStep4() {

                if(this.question_3.principal_response == 'oui'){
                    if (this.question_3.resp_date !=='' && this.question_3.resp_justification !=='' && this.question_3.resp_duree !=='') {
                        this.QuestionNext.Q4 = true
                        if(this.CheckValue(this.question_3.num)==0)
                        {
                            this.QuestionnaireTab.push(this.question_3)
                        }
                    }else {
                        this.QuestionNext.Q4 = false
                    }
                }else if(this.question_3.principal_response == 'non') {
                    this.question_3.resp_date = ''
                    this.question_3.resp_justification = ''
                    this.question_3.resp_duree = ''
                    this.QuestionNext.Q4 = true
                    this.QuestionnaireTab.push(this.question_3)

                }

            },

            QuestionControlSuiteStep5() {
                if(this.question_4.principal_response === 'oui'){
                    if (this.question_4.resp_date !=='' && this.question_4.resp_justification !=='') {
                        this.QuestionNext.Q5 = true
                        if(this.CheckValue(this.question_4.num)==0)
                        {
                            this.QuestionnaireTab.push(this.question_4)
                        }
                    }else {
                        this.QuestionNext.Q5 = false
                    }
                }else if(this.question_4.principal_response === 'non') {
                    this.question_4.resp_date = ''
                    this.question_4.resp_justification = ''
                    this.QuestionNext.Q5 = true
                    this.QuestionnaireTab.push(this.question_4)

                }


            },

            QuestionControlSuiteStep6() {
                if(this.question_5.principal_response === 'oui'){
                    if (this.question_5.resp_date !== '' && this.question_5.resp_justification !== '' && this.question_5.resp_justification_servie !== '' && this.question_5.resp_taux !== '') {
                        this.QuestionNext.Q6 = true
                        if(this.CheckValue(this.question_5.num)==0)
                        {
                            this.QuestionnaireTab.push(this.question_5)
                        }
                    }else {
                        this.QuestionNext.Q6 = false
                    }
                }else if(this.question_5.principal_response === 'non') {
                    this.question_5.resp_date = ''
                    this.question_5.resp_justification = ''
                    this.question_5.resp_justification_servie = ''
                    this.question_5.resp_taux = ''
                    this.QuestionNext.Q6 = true
                    this.QuestionnaireTab.push(this.question_5)

                }


            },

            QuestionControlSuiteStep7() {
                if(this.question_6.principal_response === 'oui'){
                    if (this.question_6.resp_date !== '' && this.question_6.resp_combien !== '') {
                        this.QuestionNext.Q7 = true
                        if(this.CheckValue(this.question_6.num)==0)
                        {
                            this.QuestionnaireTab.push(this.question_6)
                        }
                    }else {
                        this.QuestionNext.Q7 = false
                    }
                }else if(this.question_6.principal_response === 'non') {
                    this.question_6.resp_date = ''
                    this.question_6.resp_combien = ''
                    this.QuestionNext.Q7 = true
                    this.QuestionnaireTab.push(this.question_6)

                }

            },
            
            BackToBenefForm(){
                this.animation = 'animate-out-back';
                setTimeout(() => {
                    this.animation = 'animate-in-back';
                    this.activeStep -= 1;
                    this.e1 = 4;
                    this.isContractant = false,
                    this.isAssure = false,
                    this.isBenef = true
                }, 500);
            },

            QuestionControlSuiteBack(){
                this.QuestionNext.Q = true
                this.QuestionNext.Q1 = false
            },

            QuestionControlSuiteBack1(){
                this.QuestionNext.Q1 = true
                this.QuestionNext.Q2 = false
            },

            QuestionControlSuiteBack2(){
                this.QuestionNext.Q2 = true
                this.QuestionNext.Q3 = false
            },

            QuestionControlSuiteBack3(){
                this.QuestionNext.Q3 = true
                this.QuestionNext.Q4 = false
            },

            QuestionControlSuiteBack4(){
                this.QuestionNext.Q4 = true
                this.QuestionNext.Q5 = false
            },

            QuestionControlSuiteBack5(){
                this.QuestionNext.Q5 = true
                this.QuestionNext.Q6 = false
            },

            QuestionControlSuiteBack6(){
                this.QuestionNext.Q = true
                this.QuestionNext.firstPage = false
                this.QuestionNext.Q7 = false
            },

            validField() {
                    if(this.question_7.principal_response === 'oui'){
                        if(this.question_7.resp_date){
                            this.QuestionnaireTab.push(this.question_7)
                            this.step = 6
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("thirtStep").classList.add('checked');
                            this.nextStep4()
                            this.bottomPushNotif =false
                        }else {
                            this.$toasted.show("Champ obligatoire! ", this.ToastTabError)
                        }
                    } else if (this.question_7.principal_response === 'non'){
                        this.QuestionnaireTab.push(this.question_7)
                        this.step = 6
                            document.getElementById("testup").classList.add('widthFive');
                            document.getElementById("thirtStep").classList.add('checked');
                        this.nextStep4()
                        this.bottomPushNotif =false
                    }
            }
        }, 
        mounted(){
            window.scrollTo(0, 0);
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/css/button.css";
    @import "../assets/css/devis_css.css";

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.to-right {
  float: right!important;
}


    .form {
        background-color: #fff;
        padding: 1.5rem;
    }

    .form .page {
        height: auto;
    }

    button.next {
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 1.5rem;
        margin-bottom: 1rem;
    }

    button.previous {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
    }


    button.edit {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    h4 {
        color: #29323a;
        margin-bottom: 15px;
        font-weight: 600;
    }




    html {
        background-color: #1a1a1a;
        overflow: hidden;
    }
    .middle {
        width: auto;
        text-align: center;
        /* Made by */
    }
    .middle h1 {
        font-family: "Inter", sans-serif;
        color: #fff;
    }
    .middle input[type="radio"] {
        display: none;
    }
    .middle input[type="radio"]:checked + .box {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
        color: #29323a;
    }
    .middle input[type="radio"]:checked + .box span {
        color: #29323a;
        transform: translateY(70px);
    }
    .middle input[type="radio"]:checked + .box span:before {
        transform: translateY(0px);
        opacity: 1;
    }
    .middle .box {
        width: 220px;
        height: 150px;
        border-radius: 12px;
        background-color: #fff;
        transition: all 250ms ease;
        will-change: transition;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        position: relative;
        box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
        font-size: 10px;
        border: 1px solid #d9dee3;
        font-family: Open Sans,sans-serif;
        font-weight: 900;
    }
    .middle .box:hover {
        background-color: rgba(255, 164, 9, 0.07);
        transition: all .33s ease;
        border: 2px solid #ffa409;
    }
    .middle .box:hover span {
        color: #29323a;
    }

    .middle .box:active {
        transform: translateY(10px);
    }
    .middle .box span {
        position: absolute;
        transform: translate(0, 60px);
        left: 0;
        right: 0;
        padding-top: 15%;
        transition: all 300ms ease;
        font-size: 1.5em;
        user-select: none;
        color: #29323a;
    }
    .middle .box span:before {
        font-size: 1.2em;
        font-family: FontAwesome;
        display: block;
        transform: translateY(-80px);
        opacity: 0;
        transition: all 300ms ease-in-out;
        font-weight: normal;
        color: #fff;
    }
    .middle p {
        color: #fff;
        font-family: "Inter", sans-serif;
        font-weight: 400;
    }
    .middle p a {
        text-decoration: underline;
        font-weight: bold;
        color: #fff;
    }
    .middle p span:after {
        content: "\f0e7";
        font-family: FontAwesome;
        color: yellow;
    }

    .widthFirst{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:23.55556%;
    }
    .widthSecond{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:32.11112%;
    }
    .widthThirt{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:40.11112%;
    }
    .widthFour{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:50.11112%;
    }
    .widthFive{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:73.11112%;
    }
    .widthSixe{
        background-color: var(--custom-color-primary)!important;
        height: 5px;
        border-radius: 5px;
        transition: width .33s ease;
        width:100%;
    }
















    .paralax-cover-image {
        background-image: url('../assets/img/assurance/vie.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
        background-image: url('../assets/img/assurance/vie_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        // background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }

    .to-left {
  text-align: left;
}


// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
